// import React, { useState, useEffect, useRef } from 'react'
// import chatBg from '../images/bg-pattern-liveAgent.png'
// import SenderIcon from '../images/callericon.png'
// import { LuSquareArrowOutUpRight } from "react-icons/lu";
// import { FaArtstation } from "react-icons/fa";
// import { MdBlock } from "react-icons/md";
// import { IoIosArrowDown } from "react-icons/io";
// import { IoIosArrowUp } from "react-icons/io";
// import { MdAdd } from "react-icons/md";
// import { FaUser } from "react-icons/fa";
// import { FaEdit } from "react-icons/fa";
// import { MdDelete } from "react-icons/md";
// import AddNotesModal from './Addnotes';
// import { io as socketIOClient } from "socket.io-client";

// // Always use singleton socket
// let socket = null;
// function getSocket() {
//     if (!socket) {
//         socket = socketIOClient("https://wa-api.globebot.io", {
//             transports: ["websocket"],
//             reconnection: true,
//             reconnectionAttempts: Infinity,
//         });
//     }
//     return socket;
// }

// function getProfileName(user) {
//     return user?.ProfileName || user?.name || user?.from_number || "";
// }
// function getWANumber(user) {
//     return user?.WANumber || user?.from_number || "";
// }

// function decodeToken(token) {
//     if (!token) return {};
//     try {
//         const base64Url = token.split('.')[1]
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64)
//                 .split('')
//                 .map(function (c) {
//                     return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
//                 })
//                 .join('')
//         );
//         return JSON.parse(jsonPayload);
//     } catch (e) {
//         return {};
//     }
// }

// function getUserIdFromTokenOrLocatorgarsotrga() {
//     if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
//         const rawToken = window.locatorgarsotrga("token");
//         if (rawToken) {
//             const decoded = decodeToken(rawToken);
//             const userId = decoded.id || decoded.userId || decoded._id;
//             return { userId, token: rawToken };
//         }
//     }
//     const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
//     if (rawToken) {
//         const decoded = decodeToken(rawToken);
//         const userId = decoded.id || decoded.userId || decoded._id;
//         return { userId, token: rawToken };
//     }
//     return { userId: null, token: null };
// }

// function isDbMessageIncoming(msg, selectedUser) {
//     if (!selectedUser) return false;
//     const userPhone = selectedUser.from_number;
//     if (!userPhone) return false;
//     if (msg.from_number === userPhone && !msg.to_number) return true;
//     if (!msg.from_number && msg.to_number === userPhone) return false;
//     return false;
// }

// function Whatapplivechat({ selectedUser }) {
//     const chatListEndRef = useRef(null);

//     const chatKey = selectedUser?.from_number && selectedUser?.phone_number_id
//         ? selectedUser.from_number + "_" + selectedUser.phone_number_id
//         : 'unknown';

//     const [accessToken, setAccessToken] = useState("");
//     const { userId } = getUserIdFromTokenOrLocatorgarsotrga();

//     // Must keep socket event handlers in sync with current chat
//     const [allDbChats, setAllDbChats] = useState({});
//     const [chatsMap, setChatsMap] = useState({});
//     const [chatsMessageIdMap, setChatsMessageIdMap] = useState({});
//     const [newMessage, setNewMessage] = useState('');

//     // Always keep socket room in sync with selected chat
//     const prevChatKeyRef = useRef();

//     // Token fetch
//     async function fetchUserAccessToken(userId) {
//         if (!userId) return null;
//         try {
//             const res = await fetch(`https://wa-api.globebot.io/auth/access_token?user_id=${encodeURIComponent(userId)}`);
//             if (!res.ok) throw new Error(`Error fetching access_token: ${res.status}`);
//             const data = await res.json();
//             if (Array.isArray(data.access_token) && data.access_token.length > 0) {
//                 return data.access_token[0];
//             }
//             return null;
//         } catch (err) {
//             console.error('Error retrieving user access_token', err);
//             return null;
//         }
//     }

//     useEffect(() => {
//         if (!userId) {
//             setAccessToken([]);
//             return;
//         }
//         (async () => {
//             const token = await fetchUserAccessToken(userId);
//             setAccessToken(token ? [token] : []);
//         })();
//     }, [userId]);

//     // Fetch messages from API when chat changes
//     useEffect(() => {
//         async function fetchChats() {
//             if (!selectedUser?.phone_number_id || !selectedUser?.from_number) {
//                 setAllDbChats(prev => ({ ...prev, [chatKey]: [] }));
//                 return;
//             }
//             try {
//                 const res = await fetch(
//                     `https://wa-api.globebot.io/auth/messages/${encodeURIComponent(selectedUser.phone_number_id)}/${encodeURIComponent(selectedUser.from_number)}`
//                 );
//                 if (!res.ok) {
//                     if (res.status === 404) {
//                         setAllDbChats(prev => ({ ...prev, [chatKey]: [] }));
//                         return;
//                     }
//                     throw new Error(`Error fetching chat history: ${res.status}`);
//                 }
//                 const data = await res.json();
//                 let messages = Array.isArray(data) ? data : [];
//                 messages = messages.slice().sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
//                 setAllDbChats(prev => ({ ...prev, [chatKey]: messages }));
//             } catch (err) {
//                 console.error('Error retrieving chat history for', chatKey, err);
//                 setAllDbChats(prev => ({ ...prev, [chatKey]: [] }));
//             }
//         }
//         fetchChats();
//     }, [chatKey, selectedUser?.phone_number_id, selectedUser?.from_number]);

//     // === SOCKET LOGIC STARTS ===
//     useEffect(() => {
//         // Defensive checks
//         if (!selectedUser?.phone_number_id || !selectedUser?.from_number) return;

//         const s = getSocket();

//         // Leave the previous room!
//         if (prevChatKeyRef.current && prevChatKeyRef.current !== chatKey) {
//             s.emit("leave_chat", { room: prevChatKeyRef.current });
//         }
//         prevChatKeyRef.current = chatKey;

//         // Always (re-)join the correct chat room
//         s.emit("join_chat", {
//             phone_number_id: selectedUser.phone_number_id,
//             user: selectedUser.from_number,
//             room: chatKey
//         });

//         // Defensive initialize for new chat view
//         setChatsMap(prev => {
//             if (!prev[chatKey]) {
//                 return { ...prev, [chatKey]: [] };
//             }
//             return prev;
//         });

//         // Handler is re-created on chat change to ensure closure points to latest chat values
//         function handleMessage(msg) {
//             // Only process if this is for current chatKey
//             if (
//                 msg.phone_number_id === selectedUser.phone_number_id &&
//                 (msg.from === selectedUser.from_number || msg.to === selectedUser.from_number)
//             ) {
//                 const msgKey = chatKey;
//                 setChatsMap(prev => {
//                     const prevMsgs = prev[msgKey] ? [...prev[msgKey]] : [];
//                     let isDupe = false;
//                     if (msg.message_id) {
//                         isDupe = prevMsgs.some(m => m.message_id === msg.message_id);
//                     }
//                     if (!isDupe && (msg.created_at || msg.ReceivedDate)) {
//                         isDupe = prevMsgs.some(m => {
//                             const a = new Date(m.created_at || m.ReceivedDate).getTime();
//                             const b = new Date(msg.created_at || msg.ReceivedDate).getTime();
//                             return a === b;
//                         });
//                     }
//                     if (isDupe) return prev;
//                     let chatType = 'IN';
//                     if (msg.from === selectedUser.from_number) chatType = 'IN';
//                     else if (msg.to === selectedUser.from_number) chatType = 'OUT';
//                     return {
//                         ...prev,
//                         [msgKey]: [
//                             ...prevMsgs,
//                             {
//                                 ReceivedDate: typeof msg.created_at === 'string'
//                                     ? msg.created_at
//                                     : msg.created_at
//                                         ? new Date(msg.created_at).toISOString()
//                                         : new Date().toISOString(),
//                                 MessageText: msg.message || msg.text || msg.content,
//                                 ChatType: chatType,
//                                 message_id: msg.message_id || undefined,
//                                 wa_status: msg.wa_status || msg.status
//                             }
//                         ]
//                     }
//                 });
//             }
//         }

//         function handleStatus(statusData) {
//             const { phone_number_id, recipient_id, message_id, status } = statusData;
//             const key = recipient_id + '_' + phone_number_id;
//             setChatsMap(prev => {
//                 const chatMsgs = prev[key] || [];
//                 const updatedMsgs = chatMsgs.map(msg => {
//                     if (msg.message_id && msg.message_id === message_id) {
//                         return {
//                             ...msg,
//                             wa_status: status
//                         }
//                     }
//                     return msg;
//                 });
//                 return { ...prev, [key]: updatedMsgs };
//             });
//             setChatsMessageIdMap(prev => {
//                 const obj = prev[key] || {};
//                 if (obj[message_id]) {
//                     return {
//                         ...prev,
//                         [key]: {
//                             ...obj,
//                             [message_id]: {
//                                 ...obj[message_id],
//                                 wa_status: status
//                             }
//                         }
//                     };
//                 }
//                 return prev;
//             });
//         }

//         // Register handlers
//         s.on("new_message", handleMessage);
//         s.on("message_status", handleStatus);

//         // Clean up (unsubscribe)
//         return () => {
//             s.off("new_message", handleMessage);
//             s.off("message_status", handleStatus);
//         };
//     // The dependencies must include only chatKey and selectedUser for correctness
//     }, [chatKey, selectedUser]);

//     // Scroll to bottom on update
//     useEffect(() => {
//         chatListEndRef.current?.scrollIntoView({ behavior: "smooth" });
//     }, [chatKey, chatsMap, allDbChats]);

//     // 3. Sending
//     const sendMessage = async () => {
//         if (!newMessage.trim()) return;
//         try {
//             const response = await fetch("https://wa-api.globebot.io/auth/send-message", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Authorization": `Bearer ${accessToken || ""}`
//                 },
//                 body: JSON.stringify({
//                     phone_number_id: selectedUser.phone_number_id,
//                     to: selectedUser.from_number,
//                     message: newMessage,
//                     access_token: accessToken[0]
//                 })
//             });
//             let msgData = {};
//             try { msgData = await response.json(); } catch (e) { }
//             const messageId = msgData.message_id;
//             setChatsMap(prev => {
//                 const prevMsgs = prev[chatKey] || [];
//                 return {
//                     ...prev,
//                     [chatKey]: [
//                         ...prevMsgs,
//                         {
//                             ReceivedDate: new Date().toISOString(),
//                             MessageText: newMessage,
//                             ChatType: 'OUT',
//                             temp: true,
//                             message_id: messageId || undefined,
//                             wa_status: "sent"
//                         }
//                     ]
//                 };
//             });
//             if (messageId) {
//                 setChatsMessageIdMap(prev => ({
//                     ...prev,
//                     [chatKey]: {
//                         ...(prev[chatKey] || {}),
//                         [messageId]: {
//                             ReceivedDate: new Date().toISOString(),
//                             MessageText: newMessage,
//                             ChatType: 'OUT',
//                             message_id: messageId,
//                             wa_status: "sent"
//                         }
//                     }
//                 }));
//             }
//             setNewMessage('');
//         } catch (err) {
//             console.error("Send failed:", err);
//         }
//     };

//     function getCombinedMessages(dbMsgs, uiMsgs) {
//         dbMsgs = Array.isArray(dbMsgs) ? dbMsgs : [];
//         uiMsgs = Array.isArray(uiMsgs) ? uiMsgs : [];
//         const msgMap = {};
//         dbMsgs.forEach(msg => {
//             const id = msg.message_id || msg.id || msg.created_at;
//             msgMap[id] = msg;
//         });
//         uiMsgs.forEach(msg => {
//             const id = msg.message_id || msg.id || msg.ReceivedDate;
//             msgMap[id] = { ...msgMap[id], ...msg };
//         });
//         let arr = Object.values(msgMap);
//         arr = arr.sort((a, b) => {
//             const da = new Date(a.created_at || a.ReceivedDate);
//             const dbb = new Date(b.created_at || b.ReceivedDate);
//             return da - dbb;
//         });
//         return arr;
//     }

//     const dbMsgs = allDbChats[chatKey] || [];
//     const uiMsgs = chatsMap[chatKey] || [];
//     const chatsArray = getCombinedMessages(dbMsgs, uiMsgs);

//     const safeProfileName = getProfileName(selectedUser);
//     const safeWANumber = getWANumber(selectedUser);

//     function deduceChatType(chat, selectedUser) {
//         if (chat.ChatType) return chat.ChatType;
//         return isDbMessageIncoming(chat, selectedUser) ? "IN" : "OUT";
//     }

//     const lastMessage = chatsArray.length > 0 ? chatsArray[chatsArray.length - 1] : undefined;

//     function formatDisplayDate(dateValue) {
//         if (!dateValue) return '';
//         try {
//             const d = new Date(dateValue);
//             if (isNaN(d)) return String(dateValue);
//             return d.toLocaleString();
//         } catch {
//             return String(dateValue);
//         }
//     }
//     const formattedLastTime = lastMessage?.created_at || lastMessage?.ReceivedDate
//         ? formatDisplayDate(lastMessage.created_at || lastMessage?.ReceivedDate)
//         : selectedUser?.lastTime
//             ? formatDisplayDate(selectedUser.lastTime)
//             : selectedUser?.last_message_time
//                 ? formatDisplayDate(selectedUser.last_message_time)
//                 : "";

//     const [AssignAgent, setAssignAgent] = useState(false);
//     const [Notes, setNotes] = useState(false);
//     const [Customer, setCustomer] = useState(false);
//     const [Notestext, setNotestext] = useState('');

//     const [AddNotes, setAddNotes] = useState([]);
//     const [open, setOpen] = useState(false);
//     const [time, setTime] = useState('');
//     const [updateNote, setupdateNote] = useState('');
//     const [editId, setEditId] = useState(null);

//     const firstMessage = chatsArray.length > 0 ? chatsArray[0] : undefined;
//     const firstTime = firstMessage?.created_at || firstMessage?.ReceivedDate;
//     const FirstDate = firstMessage?.TimePassed || "";

//     const safeLastUserMessage = selectedUser?.LastUserMessage
//         || selectedUser?.lastMessage
//         || (
//             lastMessage?.MessageText
//                 || lastMessage?.content
//                 || lastMessage?.message
//                 || ""
//         );

//     const safeTimePassed = selectedUser?.TimePassed || "";

//     function formatDateLabel(date) {
//         if (!date) return '';
//         const d = new Date(date);
//         const today = new Date();
//         const yesterday = new Date();
//         yesterday.setDate(today.getDate() - 1);

//         if (d.toDateString() === today.toDateString()) {
//             return "Today";
//         }
//         if (d.toDateString() === yesterday.toDateString()) {
//             return "Yesterday";
//         }
//         return d.toLocaleDateString("en-GB", {
//             day: "2-digit",
//             month: "short",
//             year: "numeric",
//         });
//     }

//     const formatTime = (date) => {
//         if (!date) return '';
//         try {
//             const d = new Date(date);
//             if (isNaN(d)) return String(date);
//             return d.toLocaleTimeString([], {
//                 hour: "2-digit",
//                 minute: "2-digit",
//             });
//         } catch {
//             return String(date);
//         }
//     };

//     function getTime() {
//         const now = new Date();
//         let day = String(now.getDate()).padStart(2, '0');
//         let month = String(now.getMonth() + 1).padStart(2, '0');
//         let year = now.getFullYear();
//         let hours = now.getHours();
//         let minutes = String(now.getMinutes()).padStart(2, '0');
//         let ampm = hours >= 12 ? 'PM' : 'AM';
//         hours = hours % 12 || 12;
//         return `${month}/${day}/${year} ${String(hours).padStart(2, '0')}:${minutes}${ampm}`;
//     }

//     function addNotes() {
//         if (!Notestext.trim()) return;
//         if (editId) {
//             setAddNotes((prev) =>
//                 prev.map((item) =>
//                     item.id === editId
//                         ? { ...item, text: Notestext }
//                         : item
//                 )
//             );
//             setEditId(null);
//         } else {
//             const newNote = {
//                 id: AddNotes.length + 1,
//                 text: Notestext,
//                 time: getTime()
//             };
//             setAddNotes((prev) => [...prev, newNote]);
//         }
//         setNotestext('');
//         setOpen(false);
//     }

//     const deleteNote = (id) => {
//         const updatedNotes = AddNotes.filter((item) => item.id !== id);
//         setAddNotes(updatedNotes);
//     }

//     return (
//         <>
//             <div className='w-[100%] flex h-auto '>
//                 <div
//                     style={{ backgroundImage: `url(${chatBg})` }}
//                     className='w-[60%] bg-cover bg-center h-[500px]'>
//                     <div className='w-[100%] border-[#e3e9ef] border-b-[1px] py-2 px-4 flex gap-4'>
//                         <div className='w-[60px] h-[60px] bg-[#0000000d] rounded-full flex justify-center items-center text-[28px] uppercase font-semibold text-[#576071] '>
//                             {(safeProfileName).slice(0, 2)}
//                         </div>
//                         <div>
//                             <h3 className='text-[#000] text-[16px] font-bold capitalize'>{safeProfileName}</h3>
//                             <h3 className='text-[#858c97] text-[16px] font-bold capitalize'>{safeWANumber}</h3>
//                         </div>
//                     </div>
//                     <div className='h-[480px] overflow-y-auto'>
//                         {chatsArray.length > 0 ? (
//                             <>
//                                 {chatsArray.map((chat, index) => {
//                                     const chatReceivedDateString = chat.created_at
//                                         ? chat.created_at
//                                         : chat.ReceivedDate
//                                             ? chat.ReceivedDate
//                                             : "";
//                                     const showDate =
//                                         index === 0 ||
//                                         (chatReceivedDateString &&
//                                             (
//                                                 new Date(chatReceivedDateString).toDateString() !==
//                                                 new Date(
//                                                     chatsArray[index - 1]?.created_at ||
//                                                     chatsArray[index - 1]?.ReceivedDate ||
//                                                     undefined
//                                                 ).toDateString()
//                                             )
//                                         );
//                                     const chatType = deduceChatType(chat, selectedUser);

//                                     return (
//                                         <div className='w-[100%] px-2' key={chat?.message_id || chat?.id || chatReceivedDateString || index}>
//                                             {showDate && (
//                                                 <div className="text-center my-3 w-[100%]">
//                                                     <span className="bg-gray-200 text-xs px-3 py-1 rounded-full font-bold text-[#434a57]">
//                                                         {formatDateLabel(chat.created_at || chat.ReceivedDate)}
//                                                     </span>
//                                                 </div>
//                                             )}
//                                             <div className={`w-[100%]`}>
//                                                 <div>
//                                                     {chatType === 'IN' ?
//                                                         <div className={`flex gap-2 justify-start flex`}>
//                                                             <div className='w-[48px] h-[48px] bg-[#3f7fca26] rounded-full flex justify-center items-center text-[20px] uppercase font-semibold text-[#3f7fca] '>
//                                                                 {(safeProfileName).slice(0, 2)}
//                                                             </div>
//                                                             <div>
//                                                                 <div className='bg-[#3f80ca15] p-4 text-[13px] font-semibold text-[#121519d1] rounded-t-[20px] rounded-r-[20px] rounded-bl-none'>
//                                                                     {chat.MessageText || chat.content || chat.message}
//                                                                 </div>
//                                                                 <p className='text-[#858c97] text-[13px] font-semibold'>{formatTime(chat.created_at || chat.ReceivedDate)}</p>
//                                                             </div>
//                                                         </div>
//                                                         :
//                                                         <div className='w-[100%]'>
//                                                             <div className="flex justify-center items-center my-3 w-[100%]">
//                                                                 <span className="bg-gray-200 text-xs px-3 py-1 rounded-full font-bold text-[#434a57]">
//                                                                     service message sent
//                                                                 </span>
//                                                             </div>
//                                                             <div className={`w-[100%] flex gap-2 justify-end flex`}>
//                                                                 <div>
//                                                                     <div className={`w-[100%] bg-[#448c74] p-4 text-[13px] font-semibold text-[#ffffff] rounded-t-[20px] rounded-l-[20px] rounded-br-none`}>
//                                                                         {chat.MessageText || chat.content || chat.message}
//                                                                         {chat?.message_id && (
//                                                                             <div>
//                                                                                 <span className="block mt-1 text-[10px] font-normal text-[#c5dcba]">
//                                                                                     Status: {chat.wa_status || chat.status || "pending"}
//                                                                                 </span>
//                                                                             </div>
//                                                                         )}
//                                                                     </div>
//                                                                     <p className={`text-[#858c97] text-[13px] w-[100%] font-semibold text-end`}>{formatTime(chat.created_at || chat.ReceivedDate)}</p>
//                                                                 </div>
//                                                                 <div>
//                                                                     <img className='w-[50px] h-[50px]' src={SenderIcon} alt="" />
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     }
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     )
//                                 })}
//                                 <div ref={chatListEndRef} />
//                             </>
//                         ) : (
//                             <div className='text-center text-gray-400 p-10'>No chat history available.</div>
//                         )}
//                         <div className="w-full flex p-2 border-t bg-white">
//                             <input
//                                 type="text"
//                                 value={newMessage}
//                                 onChange={(e) => setNewMessage(e.target.value)}
//                                 placeholder="Type a message..."
//                                 className="flex-1 border rounded-lg px-3 py-2 outline-none"
//                                 onKeyDown={e => {
//                                     if (e.key === "Enter") sendMessage()
//                                 }}
//                             />
//                             <button
//                                 onClick={sendMessage}
//                                 className="ml-2 bg-[#128C7E] text-white px-4 rounded-lg"
//                             >
//                                 Send
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//                 <div className='w-[40%] p-6 bg-[#fff] min-h-screen'>
//                     <div className='w-[100%] rounded-lg'>
//                         <div className='w-[100%] flex gap-2 bg-gradient-to-br from-[#075E54] to-[#128C7E] p-6 rounded-t-[20px]'>
//                             <div className='w-[50px] h-[50px] bg-[#ada426] rounded-lg flex justify-center items-center text-[28px] uppercase font-semibold text-[#fff] '>
//                                 {(safeProfileName).slice(0, 2)}
//                             </div>
//                             <div>
//                                 <h1 className='text-[18px] text-[#fff] font-semibold '>{safeProfileName}</h1>
//                                 <h1 className='text-[18px] text-[#fff] font-semibold '>{safeWANumber}</h1>
//                             </div>
//                             <div className='text-[16px] text-[#fff] font-semibold flex items-center'>
//                                 <LuSquareArrowOutUpRight />
//                                 Export Chat
//                             </div>
//                         </div>
//                         <div className='bg-[#e5ddd536] w-[100%] p-4'>
//                             <div className='flex items-center justify-between w-[100%] '>
//                                 <span className='text-[#576071e0] text-[14px] font-semibold'>Last Message On</span>
//                                 <span className='text-[#576071e0] text-[14px] font-semibold'>
//                                     {formattedLastTime || 'N/A'}
//                                 </span>
//                             </div>
//                             <div className='flex items-center justify-between w-[100%] mt-2 '>
//                                 <span className='text-[#576071e0] text-[14px] font-semibold'>Last Active</span>
//                                 <span className='text-[#576071e0] text-[14px] font-semibold'>{safeTimePassed}</span>
//                             </div>
//                             <div className='flex items-center justify-between w-[100%] mt-2 '>
//                                 <span className='text-[#576071e0] text-[14px] font-semibold'>Last Message</span>
//                                 <span className='text-[#576071e0] text-[14px] font-semibold'>{safeLastUserMessage}</span>
//                             </div>
//                             <div className='w-[100%] mt-8'>
//                                 <span className='text-[18px] text-[#448c74] flex font-semibold items-center gap-1'>Actions <FaArtstation /></span>
//                             </div>
//                             <div className='w-[100%] border-[#000] border-t-[1px]'>
//                                 <button className='flex items-center justify-center gap-2 w-[100%] p-3 text-[#fff] font-bold text-[14px] bg-[#ed5050] hover:bg-[#e92b2b] rounded-lg mt-3'>
//                                     <MdBlock />
//                                     Block {safeProfileName}
//                                 </button>
//                                 <div className='bg-[#f6f9fc] border-[#ddd] border-[1px] rounded-t-lg p-0 mt-2 '>
//                                     <div
//                                         onClick={() => setAssignAgent(!AssignAgent)}
//                                         className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer ${AssignAgent ? 'bg-[#edf1f5]' : ''} p-2 rounded-t-lg`} >
//                                         Assign Agent  {AssignAgent ? <IoIosArrowUp /> : <IoIosArrowDown />}
//                                     </div>
//                                     {AssignAgent &&
//                                         <div className='flex gap-1 mt-2 p-2'>
//                                             <button className='border-[1px] border-[#448c74] rounded-lg p-2 hover:bg-[#448c74] text-[#448c74] hover:text-[#FFF] text-[12px] font-semibold'>
//                                                 Gurpreet
//                                             </button>
//                                             <button className='border-[1px] border-[#448c74] rounded-lg p-2 hover:bg-[#448c74] text-[#448c74] hover:text-[#FFF] text-[12px] font-semibold'>
//                                                 Abiee
//                                             </button>
//                                             <button className='border-[1px] border-[#448c74] rounded-lg p-2 hover:bg-[#448c74] text-[#448c74] hover:text-[#FFF] text-[12px] font-semibold'>
//                                                 Pradeep
//                                             </button>
//                                         </div>
//                                     }
//                                 </div>
//                                 <div className='bg-[#f6f9fc] border-[#ddd] border-[1px] rounded-t-lg p-0 mt-2 '>
//                                     <div
//                                         onClick={() => setNotes(!Notes)}
//                                         className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer ${Notes ? 'bg-[#edf1f5]' : ''} p-2 rounded-t-lg`} >
//                                         Notes {Notes ? <IoIosArrowUp /> : <IoIosArrowDown />}
//                                     </div>
//                                     {Notes &&
//                                         <div className=' mt-2 p-2'>
//                                             <button
//                                                 onClick={() => setOpen(true)}
//                                                 className='border-[1px] border-[#448c74] rounded-lg p-2 bg-[#448c74] text-[#FFF] text-[12px] font-semibold'>
//                                                 <MdAdd />
//                                             </button>
//                                             {AddNotes.length > 0 ? (
//                                                 AddNotes.map((item) => (
//                                                     <div className='w-[100%] mt-2 ' key={item.id}>
//                                                         <div className='w-[100%] bg-[#fff9db] p-2 '>
//                                                             <div className='flex justify-between  gap-2'>
//                                                                 <div className='w-[35px] h-[35px] rounded-full border-[1px] border-[#eee] bg-[#eee] flex justify-center items-center'>
//                                                                     <FaUser />
//                                                                 </div>
//                                                                 <div>
//                                                                     <h1 className='text-[#576071] text-[12px] font-semibold'>{safeProfileName}</h1>
//                                                                     <h1 className='text-[#576071] text-[12px] font-semibold'>{item.time}</h1>
//                                                                 </div>
//                                                                 <div className='flex gap-1'>
//                                                                     <button
//                                                                         onClick={() => {
//                                                                             setEditId(item.id)
//                                                                             setOpen(true)
//                                                                             setNotestext(item.text)
//                                                                         }}
//                                                                         className='p-2 border-[1px] border-[#448c74] rounded-md text-[#448c74] hover:text-[#fff] hover:bg-[#448c74]'><FaEdit /></button>
//                                                                     <button
//                                                                         onClick={() => deleteNote(item.id)}
//                                                                         className='p-2 border-[1px] border-[#ed5050] rounded-md text-[#ed5050] hover:text-[#fff] hover:bg-[#ed5050]'><MdDelete /></button>
//                                                                 </div>
//                                                             </div>
//                                                             <p className='text-[14px] text-[#576071] font-semibold mt-3'>{item.text}</p>
//                                                         </div>
//                                                     </div>
//                                                 ))
//                                             ) : <p className='w-[100%] text-center text-[#858c97] text-[14px]'> No notes available</p>
//                                             }
//                                         </div>
//                                     }
//                                 </div>
//                                 <div className='bg-[#f6f9fc] border-[#ddd] border-[1px] rounded-t-lg p-0 mt-2 '>
//                                     <div
//                                         onClick={() => setCustomer(!Customer)}
//                                         className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer ${Customer ? 'bg-[#edf1f5]' : ''} p-2 rounded-t-lg`} >
//                                         Customer Journey  {Customer ? <IoIosArrowUp /> : <IoIosArrowDown />}
//                                     </div>
//                                     {Customer &&
//                                         <div className='flex pb-4 '>
//                                             <div className='flex gap-1 mt-2  relative px-4'>
//                                                 <div className='w-[10px] h-[10px] bg-[#000] rounded-full absolute left-3  '>
//                                                 </div>
//                                                 <div className='w-[1px] h-[30px] bg-[#000] '>
//                                                 </div>
//                                             </div>
//                                             <div className='mt-1' >
//                                                 <h5 className='text-[#576071] text-[12px] font-bold'>User Created</h5>
//                                                 <h5 className='text-[#576071] text-[10px] font-bold'>
//                                                     {FirstDate}{firstTime ? formatTime(firstTime) : ''}
//                                                 </h5>
//                                             </div>
//                                         </div>
//                                     }
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <AddNotesModal isOpen={open} onClose={() => setOpen(false)} heading={'Add Note'}>
//                 <textarea name="" id=""
//                     className='border-[1px] border-[#d4cfcf] w-[100%] rounded-lg outline-none mt-4 p-2'
//                     placeholder='Write your note...'
//                     rows={4}
//                     value={Notestext}
//                     onChange={(e) => setNotestext(e.target.value)}
//                 ></textarea>
//                 <div className='w-[100%] flex items-center justify-end mt-4 gap-2'>
//                     <button className='bg-[#edf1f5] hover:bg-[#d3dde6] text-[14px] font-semibold p-2 rounded-lg '
//                     >Cancel</button>
//                     <button
//                         onClick={() => {
//                             addNotes()
//                             setOpen(false)
//                         }}
//                         className='bg-[#3fca90] hover:bg-[#31b07b] text-[14px] text-[#fff] font-semibold p-2 rounded-lg '
//                     >Save</button>
//                 </div>
//             </AddNotesModal>
//         </>
//     )
// }

// export default Whatapplivechat


// second working code 
// import React, { useState, useEffect, useRef } from 'react'
// import chatBg from '../images/bg-pattern-liveAgent.png'
// import SenderIcon from '../images/callericon.png'
// import { LuSquareArrowOutUpRight } from "react-icons/lu";
// import { FaArtstation } from "react-icons/fa";
// import { MdBlock } from "react-icons/md";
// import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
// import { MdAdd } from "react-icons/md";
// import { FaUser, FaEdit } from "react-icons/fa";
// import { MdDelete } from "react-icons/md";
// import AddNotesModal from './Addnotes';
// import { io as socketIOClient } from "socket.io-client";

// // ─── Singleton socket ─────────────────────────────────────────────────────────
// let socket = null;
// function getSocket() {
//     if (!socket) {
//         socket = socketIOClient("https://wa-api.globebot.io", {
//             transports: ["websocket"],
//             reconnection: true,
//             reconnectionAttempts: Infinity,
//             reconnectionDelay: 1000,
//         });
//     }
//     return socket;
// }

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// function getProfileName(user) {
//     return user?.ProfileName || user?.name || user?.from_number || "";
// }
// function getWANumber(user) {
//     return user?.WANumber || user?.from_number || "";
// }

// function decodeToken(token) {
//     if (!token) return {};
//     try {
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64).split('').map(c =>
//                 '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
//             ).join('')
//         );
//         return JSON.parse(jsonPayload);
//     } catch { return {}; }
// }

// function getUserIdFromToken() {
//     if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
//         const rawToken = window.locatorgarsotrga("token");
//         if (rawToken) {
//             const decoded = decodeToken(rawToken);
//             return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
//         }
//     }
//     const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
//     if (rawToken) {
//         const decoded = decodeToken(rawToken);
//         return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
//     }
//     return { userId: null, token: null };
// }

// // Determine if a DB message is incoming or outgoing
// function isDbMessageIncoming(msg, selectedUser) {
//     if (!selectedUser?.from_number) return false;
//     // from_number is set for incoming, null for outgoing (your DB schema)
//     if (msg.from_number && msg.from_number === selectedUser.from_number) return true;
//     if (!msg.from_number) return false;
//     return false;
// }

// // Merge DB messages + realtime socket messages, deduplicated and sorted
// function getCombinedMessages(dbMsgs, uiMsgs) {
//     dbMsgs = Array.isArray(dbMsgs) ? dbMsgs : [];
//     uiMsgs = Array.isArray(uiMsgs) ? uiMsgs : [];
//     const msgMap = {};
//     dbMsgs.forEach(msg => {
//         const id = msg.message_id || msg.id || msg.created_at;
//         if (id) msgMap[id] = { ...msg };
//     });
//     uiMsgs.forEach(msg => {
//         const id = msg.message_id || msg.id || msg.ReceivedDate;
//         if (id) msgMap[id] = { ...(msgMap[id] || {}), ...msg };
//     });
//     return Object.values(msgMap).sort((a, b) =>
//         new Date(a.created_at || a.ReceivedDate) - new Date(b.created_at || b.ReceivedDate)
//     );
// }

// // ─── Tick icon ────────────────────────────────────────────────────────────────
// function MessageTick({ status }) {
//     if (!status || status === 'sending')
//         return <span className="text-white opacity-50 text-[11px] ml-1">⏳</span>;
//     if (status === 'sent')
//         return <span className="text-white opacity-70 text-[11px] ml-1">✓</span>;
//     if (status === 'delivered')
//         return <span className="text-white opacity-70 text-[11px] font-bold ml-1">✓✓</span>;
//     if (status === 'read')
//         return <span className="text-[#53bdeb] text-[11px] font-bold ml-1">✓✓</span>;
//     return null;
// }

// // ─── 24hr Countdown Hook ──────────────────────────────────────────────────────
// function use24hrCountdown(firstSentAt) {
//     const [timeLeft, setTimeLeft] = useState(null);
//     const [expired, setExpired]   = useState(false);

//     useEffect(() => {
//         if (!firstSentAt) { setTimeLeft(null); setExpired(false); return; }
//         function calc() {
//             const diff = new Date(firstSentAt).getTime() + 86400000 - Date.now();
//             if (diff <= 0) { setExpired(true); setTimeLeft("00:00:00"); return false; }
//             const h = Math.floor(diff / 3600000);
//             const m = Math.floor((diff % 3600000) / 60000);
//             const s = Math.floor((diff % 60000) / 1000);
//             setTimeLeft(`${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`);
//             return true;
//         }
//         if (!calc()) return;
//         const iv = setInterval(() => { if (!calc()) clearInterval(iv); }, 1000);
//         return () => clearInterval(iv);
//     }, [firstSentAt]);

//     return { timeLeft, expired };
// }

// // ─── Main Component ───────────────────────────────────────────────────────────
// function Whatapplivechat({ selectedUser }) {
//     const { userId } = getUserIdFromToken();

//     // chatKey = from_number + "_" + phone_number_id
//     // ✅ This MUST match the room name on both socket server and webhook
//     const chatKey = selectedUser?.from_number && selectedUser?.phone_number_id
//         ? `${selectedUser.from_number}_${selectedUser.phone_number_id}`
//         : 'unknown';

//     const [accessToken,   setAccessToken]   = useState(null);
//     const [allDbChats,    setAllDbChats]     = useState({});   // from REST API
//     const [chatsMap,      setChatsMap]       = useState({});   // from socket
//     const [firstSentMap,  setFirstSentMap]   = useState({});   // for 24hr countdown
//     const [newMessage,    setNewMessage]     = useState('');
//     const chatListEndRef                     = useRef(null);
//     const prevChatKeyRef                     = useRef(null);

//     const { timeLeft, expired } = use24hrCountdown(firstSentMap[chatKey] || null);

//     // ── Access token ──────────────────────────────────────────────────────
//     useEffect(() => {
//         if (!userId) { setAccessToken(null); return; }
//         fetch(`https://wa-api.globebot.io/auth/access_token?user_id=${encodeURIComponent(userId)}`)
//             .then(r => r.json())
//             .then(data => {
//                 setAccessToken(Array.isArray(data.access_token) ? data.access_token[0] : null);
//             })
//             .catch(err => console.error('Error retrieving access_token', err));
//     }, [userId]);

//     // ── Load message history from REST API ────────────────────────────────
//     useEffect(() => {
//         if (!selectedUser?.phone_number_id || !selectedUser?.from_number) return;

//         fetch(
//             `https://wa-api.globebot.io/auth/messages/${encodeURIComponent(selectedUser.phone_number_id)}/${encodeURIComponent(selectedUser.from_number)}`
//         )
//             .then(r => {
//                 if (r.status === 404) return [];
//                 if (!r.ok) throw new Error(`HTTP ${r.status}`);
//                 return r.json();
//             })
//             .then(data => {
//                 const msgs = Array.isArray(data) ? data : [];
//                 const sorted = [...msgs].sort((a, b) =>
//                     new Date(a.created_at) - new Date(b.created_at)
//                 );
//                 setAllDbChats(prev => ({ ...prev, [chatKey]: sorted }));

//                 // Restore 24hr countdown from earliest outgoing message
//                 const firstOut = sorted.find(m => !m.from_number);
//                 if (firstOut?.created_at) {
//                     setFirstSentMap(prev => prev[chatKey] ? prev : { ...prev, [chatKey]: firstOut.created_at });
//                 }
//             })
//             .catch(err => console.error('Error loading chat history:', err));
//         // eslint-disable-next-line
//     }, [chatKey]);

//     // ── Socket: join room, handle messages + status ───────────────────────
//     useEffect(() => {
//         if (!selectedUser?.phone_number_id || !selectedUser?.from_number) return;

//         const s = getSocket();

//         // ✅ Room = from_number + "_" + phone_number_id
//         // Matches webhook: const room = `${from}_${phoneNumberId}`
//         // Matches socket server: resolvedRoom = room || `${user}_${phone_number_id}`
//         const room = chatKey;

//         // Leave previous room when switching chats
//         if (prevChatKeyRef.current && prevChatKeyRef.current !== room) {
//             s.emit("leave_chat", { room: prevChatKeyRef.current });
//             console.log("👋 Left room:", prevChatKeyRef.current);
//         }
//         prevChatKeyRef.current = room;

//         function joinRoom() {
//             s.emit("join_chat", {
//                 phone_number_id: selectedUser.phone_number_id,
//                 user:            selectedUser.from_number,
//                 room,            // ✅ send explicit room so backend uses same string
//             });
//             console.log("🔌 Joined room:", room);
//         }

//         // Join immediately
//         joinRoom();

//         // Rejoin on reconnect (socket drop recovery)
//         s.on("connect", joinRoom);

//         // ── Incoming message from customer ────────────────────────────────
//         function handleNewMessage(msg) {
//             console.log("📨 new_message received:", msg);

//             // ✅ Build the key from socket payload — same formula as chatKey
//             // msg.from = customer number, msg.phone_number_id = business number
//             const msgKey = `${msg.from}_${msg.phone_number_id}`;

//             setChatsMap(prev => {
//                 const prevMsgs = prev[msgKey] || [];
//                 // Deduplicate by message_id
//                 if (msg.message_id && prevMsgs.some(m => m.message_id === msg.message_id)) {
//                     return prev;
//                 }
//                 return {
//                     ...prev,
//                     [msgKey]: [
//                         ...prevMsgs,
//                         {
//                             message_id:   msg.message_id,
//                             ReceivedDate: msg.created_at || new Date().toISOString(),
//                             created_at:   msg.created_at || new Date().toISOString(),
//                             MessageText:  msg.message,
//                             content:      msg.message,
//                             ChatType:     'IN',
//                             from_number:  msg.from,
//                             wa_status:    'received',
//                         }
//                     ]
//                 };
//             });
//         }

//         // ── Delivery/read receipt ─────────────────────────────────────────
//         function handleStatus(data) {
//             console.log("📩 message_status received:", data);
//             // { phone_number_id, message_id, status, recipient_id }
//             const msgKey = `${data.recipient_id}_${data.phone_number_id}`;

//             // Update in chatsMap (socket messages)
//             setChatsMap(prev => {
//                 const msgs = prev[msgKey];
//                 if (!msgs) return prev;
//                 return {
//                     ...prev,
//                     [msgKey]: msgs.map(m =>
//                         m.message_id === data.message_id
//                             ? { ...m, wa_status: data.status }
//                             : m
//                     )
//                 };
//             });

//             // Update in allDbChats (REST history messages)
//             setAllDbChats(prev => {
//                 const msgs = prev[msgKey];
//                 if (!msgs) return prev;
//                 return {
//                     ...prev,
//                     [msgKey]: msgs.map(m =>
//                         m.message_id === data.message_id
//                             ? { ...m, status: data.status, wa_status: data.status }
//                             : m
//                     )
//                 };
//             });
//         }

//         s.on("new_message",    handleNewMessage);
//         s.on("message_status", handleStatus);

//         return () => {
//             s.off("connect",        joinRoom);
//             s.off("new_message",    handleNewMessage);
//             s.off("message_status", handleStatus);
//         };
//         // eslint-disable-next-line
//     }, [chatKey]);

//     // Auto scroll to bottom
//     useEffect(() => {
//         chatListEndRef.current?.scrollIntoView({ behavior: "smooth" });
//     }, [chatKey, chatsMap, allDbChats]);

//     // ── Send message ──────────────────────────────────────────────────────
//     const sendMessage = async () => {
//         if (!newMessage.trim() || expired) return;

//         const tempId  = `temp_${Date.now()}`;
//         const sentAt  = new Date().toISOString();
//         const msgText = newMessage;

//         // Optimistic UI
//         setChatsMap(prev => ({
//             ...prev,
//             [chatKey]: [
//                 ...(prev[chatKey] || []),
//                 {
//                     message_id:   tempId,
//                     ReceivedDate: sentAt,
//                     created_at:   sentAt,
//                     MessageText:  msgText,
//                     content:      msgText,
//                     ChatType:     'OUT',
//                     from_number:  null,
//                     wa_status:    'sending',
//                     temp:         true,
//                 }
//             ]
//         }));
//         setNewMessage('');

//         // Start 24hr countdown on first outgoing message
//         setFirstSentMap(prev => prev[chatKey] ? prev : { ...prev, [chatKey]: sentAt });

//         try {
//             const res  = await fetch("https://wa-api.globebot.io/auth/send-message", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type":  "application/json",
//                     "Authorization": `Bearer ${accessToken || ""}`,
//                 },
//                 body: JSON.stringify({
//                     phone_number_id: selectedUser.phone_number_id,
//                     to:              selectedUser.from_number,
//                     message:         msgText,
//                     access_token:    accessToken,
//                 })
//             });

//             const result = await res.json();
//             const realId = result?.message_id;

//             if (realId) {
//                 // Replace temp id with real message_id
//                 setChatsMap(prev => ({
//                     ...prev,
//                     [chatKey]: (prev[chatKey] || []).map(m =>
//                         m.message_id === tempId
//                             ? { ...m, message_id: realId, wa_status: 'sent', temp: false }
//                             : m
//                     )
//                 }));
//             }
//         } catch (err) {
//             console.error("Send failed:", err);
//             setChatsMap(prev => ({
//                 ...prev,
//                 [chatKey]: (prev[chatKey] || []).map(m =>
//                     m.message_id === tempId ? { ...m, wa_status: 'failed' } : m
//                 )
//             }));
//         }
//     };

//     // ── Merged message list ───────────────────────────────────────────────
//     const dbMsgs    = allDbChats[chatKey] || [];
//     const uiMsgs    = chatsMap[chatKey]   || [];
//     const chatsArray = getCombinedMessages(dbMsgs, uiMsgs);

//     // ── Derived values ────────────────────────────────────────────────────
//     const safeProfileName  = getProfileName(selectedUser);
//     const safeWANumber     = getWANumber(selectedUser);
//     const firstMessage     = chatsArray[0];
//     const lastMessage      = chatsArray[chatsArray.length - 1];
//     const safeLastUserMsg  = selectedUser?.LastUserMessage || selectedUser?.lastMessage
//         || lastMessage?.MessageText || lastMessage?.content || lastMessage?.message || "";
//     const safeTimePassed   = selectedUser?.TimePassed || "";

//     function deduceChatType(chat) {
//         if (chat.ChatType) return chat.ChatType;
//         return isDbMessageIncoming(chat, selectedUser) ? 'IN' : 'OUT';
//     }

//     function formatDisplayDate(v) {
//         if (!v) return '';
//         try { const d = new Date(v); return isNaN(d) ? String(v) : d.toLocaleString(); }
//         catch { return String(v); }
//     }

//     function formatDateLabel(date) {
//         if (!date) return '';
//         const d = new Date(date);
//         const today     = new Date();
//         const yesterday = new Date(); yesterday.setDate(today.getDate() - 1);
//         if (d.toDateString() === today.toDateString())     return "Today";
//         if (d.toDateString() === yesterday.toDateString()) return "Yesterday";
//         return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
//     }

//     const formatTime = (date) => {
//         if (!date) return '';
//         try {
//             const d = new Date(date);
//             return isNaN(d) ? String(date) : d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
//         } catch { return String(date); }
//     };

//     const formattedLastTime = lastMessage
//         ? formatDisplayDate(lastMessage.created_at || lastMessage.ReceivedDate)
//         : formatDisplayDate(selectedUser?.lastTime || selectedUser?.last_message_time || "");

//     function countdownColor() {
//         if (!timeLeft || expired) return '#ed5050';
//         const [h] = timeLeft.split(':').map(Number);
//         return h < 1 ? '#f59e0b' : '#448c74';
//     }

//     function getTime() {
//         const now = new Date();
//         let h = now.getHours(); const ampm = h >= 12 ? 'PM' : 'AM'; h = h % 12 || 12;
//         return `${String(now.getMonth()+1).padStart(2,'0')}/${String(now.getDate()).padStart(2,'0')}/${now.getFullYear()} ${String(h).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}${ampm}`;
//     }

//     // ── Notes state ───────────────────────────────────────────────────────
//     const [AssignAgent, setAssignAgent] = useState(false);
//     const [Notes,       setNotes]       = useState(false);
//     const [Customer,    setCustomer]    = useState(false);
//     const [Notestext,   setNotestext]   = useState('');
//     const [AddNotes,    setAddNotes]    = useState([]);
//     const [open,        setOpen]        = useState(false);
//     const [editId,      setEditId]      = useState(null);

//     function addNotes() {
//         if (!Notestext.trim()) return;
//         if (editId) {
//             setAddNotes(prev => prev.map(item => item.id === editId ? { ...item, text: Notestext } : item));
//             setEditId(null);
//         } else {
//             setAddNotes(prev => [...prev, { id: Date.now(), text: Notestext, time: getTime() }]);
//         }
//         setNotestext(''); setOpen(false);
//     }
//     const deleteNote = (id) => setAddNotes(prev => prev.filter(item => item.id !== id));

//     // ─────────────────────────────────────────────────────────────────────
//     return (
//         <>
//             <div className='w-[100%] flex h-auto'>

//                 {/* ══════════════ CHAT PANEL ══════════════ */}
//                 <div
//                     style={{ backgroundImage: `url(${chatBg})` }}
//                     className='w-[60%] bg-cover bg-center flex flex-col'
//                     style={{ height: '600px' }}
//                 >
//                     {/* Header */}
//                     <div className='w-[100%] border-[#e3e9ef] border-b-[1px] py-2 px-4 flex gap-4 items-center justify-between bg-white shrink-0'>
//                         <div className='flex gap-4 items-center'>
//                             <div className='w-[60px] h-[60px] bg-[#0000000d] rounded-full flex justify-center items-center text-[28px] uppercase font-semibold text-[#576071]'>
//                                 {safeProfileName.slice(0, 2)}
//                             </div>
//                             <div>
//                                 <h3 className='text-[#000] text-[16px] font-bold capitalize'>{safeProfileName}</h3>
//                                 <h3 className='text-[#858c97] text-[14px] font-semibold'>{safeWANumber}</h3>
//                             </div>
//                         </div>

//                         {/* 24hr countdown badge */}
//                         {timeLeft && (
//                             <div
//                                 style={{ backgroundColor: countdownColor() }}
//                                 className='flex flex-col items-center px-3 py-1 rounded-lg text-white min-w-[110px]'
//                             >
//                                 <span className='text-[10px] font-semibold uppercase tracking-wide'>
//                                     {expired ? 'Window Closed' : '24hr Window'}
//                                 </span>
//                                 <span className='text-[16px] font-bold font-mono'>{timeLeft}</span>
//                             </div>
//                         )}
//                     </div>

//                     {/* Messages */}
//                     <div className='flex-1 overflow-y-auto px-2 py-2'>
//                         {chatsArray.length > 0 ? (
//                             chatsArray.map((chat, index) => {
//                                 const dateStr  = chat.created_at || chat.ReceivedDate;
//                                 const prevDate = index > 0
//                                     ? new Date(chatsArray[index-1].created_at || chatsArray[index-1].ReceivedDate).toDateString()
//                                     : null;
//                                 const showDate = !prevDate || new Date(dateStr).toDateString() !== prevDate;
//                                 const chatType = deduceChatType(chat);
//                                 const msgText  = chat.MessageText || chat.content || chat.message || "";
//                                 const msgStatus = chat.wa_status || chat.status;

//                                 return (
//                                     <div className='w-[100%]' key={chat.message_id || chat.id || dateStr || index}>

//                                         {showDate && (
//                                             <div className="text-center my-3">
//                                                 <span className="bg-gray-200 text-xs px-3 py-1 rounded-full font-bold text-[#434a57]">
//                                                     {formatDateLabel(dateStr)}
//                                                 </span>
//                                             </div>
//                                         )}

//                                         {chatType === 'IN' ? (
//                                             /* Incoming */
//                                             <div className='flex gap-2 justify-start mb-3'>
//                                                 <div className='w-[48px] h-[48px] bg-[#3f7fca26] rounded-full flex justify-center items-center text-[18px] uppercase font-semibold text-[#3f7fca] shrink-0'>
//                                                     {safeProfileName.slice(0, 2)}
//                                                 </div>
//                                                 <div className='max-w-[65%]'>
//                                                     <div className='bg-[#3f80ca15] p-3 text-[13px] font-semibold text-[#121519d1] rounded-t-[20px] rounded-r-[20px] rounded-bl-none'>
//                                                         {msgText}
//                                                     </div>
//                                                     <p className='text-[#858c97] text-[12px] font-semibold mt-1'>
//                                                         {formatTime(dateStr)}
//                                                     </p>
//                                                 </div>
//                                             </div>
//                                         ) : (
//                                             /* Outgoing */
//                                             <div className='w-[100%] mb-3'>
//                                                 <div className="flex justify-center items-center my-1">
//                                                     <span className="bg-gray-200 text-xs px-3 py-1 rounded-full font-bold text-[#434a57]">
//                                                         service message sent
//                                                     </span>
//                                                 </div>
//                                                 <div className='flex gap-2 justify-end items-end'>
//                                                     <div className='max-w-[65%]'>
//                                                         <div className='bg-[#448c74] p-3 text-[13px] font-semibold text-white rounded-t-[20px] rounded-l-[20px] rounded-br-none flex items-end gap-2'>
//                                                             <span>{msgText}</span>
//                                                             <MessageTick status={msgStatus} />
//                                                         </div>
//                                                         <p className='text-[#858c97] text-[12px] font-semibold text-end mt-1'>
//                                                             {formatTime(dateStr)}
//                                                         </p>
//                                                     </div>
//                                                     <img className='w-[46px] h-[46px] shrink-0' src={SenderIcon} alt="" />
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 );
//                             })
//                         ) : (
//                             <div className='text-center text-gray-400 p-10'>No chat history available.</div>
//                         )}
//                         <div ref={chatListEndRef} />
//                     </div>

//                     {/* Input */}
//                     <div className="w-full flex flex-col p-2 border-t bg-white shrink-0">
//                         {expired && (
//                             <div className='w-full text-center text-[12px] text-[#ed5050] font-semibold mb-2 bg-[#fff0f0] py-1 rounded-lg'>
//                                 ⚠️ 24-hour messaging window has closed. You can only send template messages.
//                             </div>
//                         )}
//                         <div className='flex'>
//                             <input
//                                 type="text"
//                                 value={newMessage}
//                                 onChange={(e) => setNewMessage(e.target.value)}
//                                 onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
//                                 placeholder={expired ? "Window closed — use a template message" : "Type a message..."}
//                                 disabled={expired}
//                                 className={`flex-1 border rounded-lg px-3 py-2 outline-none text-[14px] ${expired ? 'bg-gray-100 cursor-not-allowed text-gray-400' : ''}`}
//                             />
//                             <button
//                                 onClick={sendMessage}
//                                 disabled={expired}
//                                 className={`ml-2 px-4 rounded-lg text-white font-semibold text-[14px] ${expired ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#128C7E] hover:bg-[#075E54]'}`}
//                             >
//                                 Send
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* ══════════════ RIGHT PANEL ══════════════ */}
//                 <div className='w-[40%] p-6 bg-[#fff] min-h-screen overflow-y-auto'>
//                     <div className='w-[100%] rounded-lg'>

//                         <div className='w-[100%] flex gap-2 bg-gradient-to-br from-[#075E54] to-[#128C7E] p-6 rounded-t-[20px] items-center'>
//                             <div className='w-[50px] h-[50px] bg-[#ada426] rounded-lg flex justify-center items-center text-[22px] uppercase font-semibold text-white shrink-0'>
//                                 {safeProfileName.slice(0, 2)}
//                             </div>
//                             <div className='flex-1 min-w-0'>
//                                 <h1 className='text-[16px] text-white font-semibold truncate'>{safeProfileName}</h1>
//                                 <h1 className='text-[14px] text-white font-semibold'>{safeWANumber}</h1>
//                             </div>
//                             <div className='text-[14px] text-white font-semibold flex items-center gap-1 cursor-pointer shrink-0'>
//                                 <LuSquareArrowOutUpRight /> Export Chat
//                             </div>
//                         </div>

//                         <div className='bg-[#e5ddd536] w-[100%] p-4'>
//                             <div className='flex items-center justify-between w-[100%]'>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold'>Last Message On</span>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold'>{formattedLastTime || 'N/A'}</span>
//                             </div>
//                             <div className='flex items-center justify-between w-[100%] mt-2'>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold'>Last Active</span>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold'>{safeTimePassed}</span>
//                             </div>
//                             <div className='flex items-center justify-between w-[100%] mt-2'>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold'>Last Message</span>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold truncate max-w-[55%]'>{safeLastUserMsg}</span>
//                             </div>
//                             {timeLeft && (
//                                 <div className='flex items-center justify-between w-[100%] mt-2 border-t border-[#ddd] pt-2'>
//                                     <span className='text-[#576071e0] text-[13px] font-semibold'>Messaging Window</span>
//                                     <span style={{ color: countdownColor() }} className='text-[13px] font-bold font-mono'>
//                                         {expired ? 'Closed' : timeLeft}
//                                     </span>
//                                 </div>
//                             )}

//                             <div className='w-[100%] mt-6'>
//                                 <span className='text-[18px] text-[#448c74] flex font-semibold items-center gap-1'>
//                                     Actions <FaArtstation />
//                                 </span>
//                             </div>
//                             <div className='w-[100%] border-[#000] border-t-[1px]'>
//                                 <button className='flex items-center justify-center gap-2 w-[100%] p-3 text-white font-bold text-[14px] bg-[#ed5050] hover:bg-[#e92b2b] rounded-lg mt-3'>
//                                     <MdBlock /> Block {safeProfileName}
//                                 </button>

//                                 {/* Assign Agent */}
//                                 <div className='bg-[#f6f9fc] border-[#ddd] border-[1px] rounded-lg mt-2'>
//                                     <div onClick={() => setAssignAgent(!AssignAgent)}
//                                         className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer ${AssignAgent ? 'bg-[#edf1f5]' : ''} p-2 rounded-t-lg`}>
//                                         Assign Agent {AssignAgent ? <IoIosArrowUp /> : <IoIosArrowDown />}
//                                     </div>
//                                     {AssignAgent && (
//                                         <div className='flex flex-wrap gap-1 mt-2 p-2'>
//                                             {['Gurpreet', 'Abiee', 'Pradeep'].map(name => (
//                                                 <button key={name} className='border border-[#448c74] rounded-lg p-2 hover:bg-[#448c74] text-[#448c74] hover:text-white text-[12px] font-semibold'>
//                                                     {name}
//                                                 </button>
//                                             ))}
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* Notes */}
//                                 <div className='bg-[#f6f9fc] border-[#ddd] border-[1px] rounded-lg mt-2'>
//                                     <div onClick={() => setNotes(!Notes)}
//                                         className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer ${Notes ? 'bg-[#edf1f5]' : ''} p-2 rounded-t-lg`}>
//                                         Notes {Notes ? <IoIosArrowUp /> : <IoIosArrowDown />}
//                                     </div>
//                                     {Notes && (
//                                         <div className='mt-2 p-2'>
//                                             <button onClick={() => setOpen(true)}
//                                                 className='border border-[#448c74] rounded-lg p-2 bg-[#448c74] text-white text-[12px] font-semibold'>
//                                                 <MdAdd />
//                                             </button>
//                                             {AddNotes.length > 0 ? AddNotes.map(item => (
//                                                 <div className='w-[100%] mt-2' key={item.id}>
//                                                     <div className='w-[100%] bg-[#fff9db] p-2 rounded'>
//                                                         <div className='flex justify-between gap-2 items-center'>
//                                                             <div className='w-[35px] h-[35px] rounded-full bg-[#eee] flex justify-center items-center shrink-0'>
//                                                                 <FaUser />
//                                                             </div>
//                                                             <div className='flex-1 min-w-0'>
//                                                                 <h1 className='text-[#576071] text-[12px] font-semibold truncate'>{safeProfileName}</h1>
//                                                                 <h1 className='text-[#576071] text-[11px]'>{item.time}</h1>
//                                                             </div>
//                                                             <div className='flex gap-1 shrink-0'>
//                                                                 <button onClick={() => { setEditId(item.id); setOpen(true); setNotestext(item.text); }}
//                                                                     className='p-2 border border-[#448c74] rounded-md text-[#448c74] hover:text-white hover:bg-[#448c74]'>
//                                                                     <FaEdit />
//                                                                 </button>
//                                                                 <button onClick={() => deleteNote(item.id)}
//                                                                     className='p-2 border border-[#ed5050] rounded-md text-[#ed5050] hover:text-white hover:bg-[#ed5050]'>
//                                                                     <MdDelete />
//                                                                 </button>
//                                                             </div>
//                                                         </div>
//                                                         <p className='text-[13px] text-[#576071] font-semibold mt-2'>{item.text}</p>
//                                                     </div>
//                                                 </div>
//                                             )) : (
//                                                 <p className='w-[100%] text-center text-[#858c97] text-[14px] mt-2'>No notes available</p>
//                                             )}
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* Customer Journey */}
//                                 <div className='bg-[#f6f9fc] border-[#ddd] border-[1px] rounded-lg mt-2'>
//                                     <div onClick={() => setCustomer(!Customer)}
//                                         className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer ${Customer ? 'bg-[#edf1f5]' : ''} p-2 rounded-t-lg`}>
//                                         Customer Journey {Customer ? <IoIosArrowUp /> : <IoIosArrowDown />}
//                                     </div>
//                                     {Customer && (
//                                         <div className='flex pb-4 px-3 pt-3 gap-3'>
//                                             <div className='flex flex-col items-center gap-1'>
//                                                 <div className='w-[10px] h-[10px] bg-[#000] rounded-full'></div>
//                                                 <div className='w-[1px] h-[30px] bg-[#000]'></div>
//                                             </div>
//                                             <div>
//                                                 <h5 className='text-[#576071] text-[12px] font-bold'>User Created</h5>
//                                                 <h5 className='text-[#576071] text-[11px]'>
//                                                     {firstMessage ? formatTime(firstMessage.created_at || firstMessage.ReceivedDate) : '—'}
//                                                 </h5>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Notes Modal */}
//             <AddNotesModal isOpen={open} onClose={() => { setOpen(false); setNotestext(''); setEditId(null); }} heading={editId ? 'Edit Note' : 'Add Note'}>
//                 <textarea
//                     className='border border-[#d4cfcf] w-[100%] rounded-lg outline-none mt-4 p-2'
//                     placeholder='Write your note...'
//                     rows={4}
//                     value={Notestext}
//                     onChange={(e) => setNotestext(e.target.value)}
//                 />
//                 <div className='w-[100%] flex items-center justify-end mt-4 gap-2'>
//                     <button onClick={() => { setOpen(false); setNotestext(''); setEditId(null); }}
//                         className='bg-[#edf1f5] hover:bg-[#d3dde6] text-[14px] font-semibold p-2 rounded-lg'>
//                         Cancel
//                     </button>
//                     <button onClick={addNotes}
//                         className='bg-[#3fca90] hover:bg-[#31b07b] text-[14px] text-white font-semibold p-2 rounded-lg'>
//                         Save
//                     </button>
//                 </div>
//             </AddNotesModal>
//         </>
//     );
// }

// export default Whatapplivechat;


// import React, { useState, useEffect, useRef } from 'react'
// import chatBg from '../images/bg-pattern-liveAgent.png'
// import SenderIcon from '../images/callericon.png'
// import { LuSquareArrowOutUpRight } from "react-icons/lu";
// import { FaArtstation } from "react-icons/fa";
// import { MdBlock } from "react-icons/md";
// import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
// import { MdAdd } from "react-icons/md";
// import { FaUser, FaEdit } from "react-icons/fa";
// import { MdDelete } from "react-icons/md";
// import AddNotesModal from './Addnotes';
// import { io as socketIOClient } from "socket.io-client";

// // ─── Singleton socket ─────────────────────────────────────────────────────────
// let socket = null;
// function getSocket() {
//     if (!socket) {
//         socket = socketIOClient("https://wa-api.globebot.io", {
//             transports: ["websocket"],
//             reconnection: true,
//             reconnectionAttempts: Infinity,
//             reconnectionDelay: 1000,
//         });
//     }
//     return socket;
// }

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// function getProfileName(user) {
//     return user?.ProfileName || user?.name || user?.from_number || "";
// }
// function getWANumber(user) {
//     return user?.WANumber || user?.from_number || "";
// }

// function decodeToken(token) {
//     if (!token) return {};
//     try {
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64).split('').map(c =>
//                 '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
//             ).join('')
//         );
//         return JSON.parse(jsonPayload);
//     } catch { return {}; }
// }

// function getUserIdFromToken() {
//     if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
//         const rawToken = window.locatorgarsotrga("token");
//         if (rawToken) {
//             const decoded = decodeToken(rawToken);
//             return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
//         }
//     }
//     const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
//     if (rawToken) {
//         const decoded = decodeToken(rawToken);
//         return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
//     }
//     return { userId: null, token: null };
// }

// function isDbMessageIncoming(msg, selectedUser) {
//     if (!selectedUser?.from_number) return false;
//     if (msg.from_number && msg.from_number === selectedUser.from_number) return true;
//     if (!msg.from_number) return false;
//     return false;
// }

// function getCombinedMessages(dbMsgs, uiMsgs) {
//     dbMsgs = Array.isArray(dbMsgs) ? dbMsgs : [];
//     uiMsgs = Array.isArray(uiMsgs) ? uiMsgs : [];
//     const msgMap = {};
//     dbMsgs.forEach(msg => {
//         const id = msg.message_id || msg.id || msg.created_at;
//         if (id) msgMap[id] = { ...msg };
//     });
//     uiMsgs.forEach(msg => {
//         const id = msg.message_id || msg.id || msg.ReceivedDate;
//         if (id) msgMap[id] = { ...(msgMap[id] || {}), ...msg };
//     });
//     return Object.values(msgMap).sort((a, b) =>
//         new Date(a.created_at || a.ReceivedDate) - new Date(b.created_at || b.ReceivedDate)
//     );
// }

// // ─── Tick icon ────────────────────────────────────────────────────────────────
// function MessageTick({ status }) {
//     if (!status || status === 'sending')
//         return <span className="text-white opacity-50 text-[11px] ml-1">⏳</span>;
//     if (status === 'sent')
//         return <span className="text-white opacity-70 text-[11px] ml-1">✓</span>;
//     if (status === 'delivered')
//         return <span className="text-white opacity-70 text-[11px] font-bold ml-1">✓✓</span>;
//     if (status === 'read')
//         return <span className="text-[#53bdeb] text-[11px] font-bold ml-1">✓✓</span>;
//     return null;
// }

// // ─── 24hr Countdown Hook ──────────────────────────────────────────────────────
// // windowStartAt: ISO timestamp of the LAST incoming message
// // Renews every time a new incoming message arrives.
// function use24hrCountdown(windowStartAt) {
//     const [timeLeft, setTimeLeft] = useState(null);
//     const [expired,  setExpired]  = useState(true); // default closed until a message arrives

//     useEffect(() => {
//         if (!windowStartAt) {
//             setTimeLeft(null);
//             setExpired(true);
//             return;
//         }

//         function calc() {
//             const deadline = new Date(windowStartAt).getTime() + 24 * 60 * 60 * 1000;
//             console.log("windowStartAt ", windowStartAt);
//             const diff     = deadline - Date.now();
//             if (diff <= 0) {
//                 setExpired(true);
//                 setTimeLeft("00:00:00");
//                 return false;
//             }
//             setExpired(false);
//             const h = Math.floor(diff / 3600000);
//             const m = Math.floor((diff % 3600000) / 60000);
//             const s = Math.floor((diff % 60000) / 1000);
//             setTimeLeft(
//                 `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`
//             );
//             return true;
//         }

//         if (!calc()) return;
//         const iv = setInterval(() => { if (!calc()) clearInterval(iv); }, 1000);
//         return () => clearInterval(iv);
//     }, [windowStartAt]);
      
//    console.log("timeLeft ", timeLeft); 
//     return { timeLeft, expired };
// }

// // ─── Main Component ───────────────────────────────────────────────────────────
// function Whatapplivechat({ selectedUser }) {
//     const { userId } = getUserIdFromToken();

    

//     // chatKey = from_number + "_" + phone_number_id  (matches socket room & webhook)
//     const chatKey = selectedUser?.from_number && selectedUser?.phone_number_id
//         ? `${selectedUser.from_number}_${selectedUser.phone_number_id}`
//         : 'unknown';

//     const [accessToken,  setAccessToken]  = useState(null);
//     const [allDbChats,   setAllDbChats]   = useState({});
//     const [chatsMap,     setChatsMap]     = useState({});
//     const [newMessage,   setNewMessage]   = useState('');

//     // windowMap: { [chatKey]: ISO string of LAST incoming message time }
//     // Sourced from: DB /window-status API on load, then kept live via socket events.
//     const [windowMap,    setWindowMap]    = useState({});

//     // metaClosedMap: { [chatKey]: boolean }
//     // Set to true when Meta sends error 131047 (window_closed socket event).
//     // This is ground truth — overrides our local timestamp calculation.
//     const [metaClosedMap, setMetaClosedMap] = useState({});

//     // renewChecked: { [chatKey]: boolean }
//     // Agent must tick this after a new customer message arrives post-expiry.
//     const [renewChecked,  setRenewChecked]  = useState({});

//     const chatListEndRef = useRef(null);
//     const prevChatKeyRef = useRef(null);

//     const windowStartAt  = windowMap[chatKey]    || null;
//     const metaClosed     = metaClosedMap[chatKey] || false;
//     const { timeLeft, expired: timerExpired } = use24hrCountdown(windowStartAt);



//     // Window is expired if Meta confirmed it, OR if our local timer ran out
//     const expired    = metaClosed || timerExpired;
//     const canSend    = !expired;

//     // ── Access token ──────────────────────────────────────────────────────
//     useEffect(() => {
//         if (!userId) { setAccessToken(null); return; }
//         fetch(`https://wa-api.globebot.io/auth/access_token?user_id=${encodeURIComponent(userId)}`)
//             .then(r => r.json())
//             .then(data => setAccessToken(Array.isArray(data.access_token) ? data.access_token[0] : null))
//             .catch(err => console.error('Error retrieving access_token', err));
//     }, [userId]);

//     // ── Load message history + window status from API ─────────────────────
//     useEffect(() => {
//         if (!selectedUser?.phone_number_id || !selectedUser?.from_number) return;

//         // Load messages
//         fetch(
//             `https://wa-api.globebot.io/auth/messages/${encodeURIComponent(selectedUser.phone_number_id)}/${encodeURIComponent(selectedUser.from_number)}`
//         )
//             .then(r => { if (r.status === 404) return []; if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
//             .then(data => {
//                 const msgs   = Array.isArray(data) ? data : [];
//                 const sorted = [...msgs].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
//                 setAllDbChats(prev => ({ ...prev, [chatKey]: sorted }));
//             })
//             .catch(err => console.error('Error loading chat history:', err));

//         // ✅ Load window status from DB (source of truth from Meta)
//         // This tells us the REAL window state, not a guess from message timestamps.
//         fetch(
//             `https://wa-api.globebot.io/auth/window-status?phone_number_id=${encodeURIComponent(selectedUser.phone_number_id)}&customer_number=${encodeURIComponent(selectedUser.from_number)}`
//         )
//             .then(r => r.json())
//             .then(data => {
//                 // data = { window_open: boolean, last_customer_message_at: string | null }
//                 if (data.last_customer_message_at) {
//                     setWindowMap(prev => ({ ...prev, [chatKey]: data.last_customer_message_at }));
//                 }
//                 if (!data.window_open) {
//                     // Meta confirmed window is closed — set metaClosed so input is locked
//                     setMetaClosedMap(prev => ({ ...prev, [chatKey]: true }));
//                 } else {
//                     setMetaClosedMap(prev => ({ ...prev, [chatKey]: false }));
//                 }
//             })
//             .catch(err => console.error('Error loading window status:', err));

//         // eslint-disable-next-line
//     }, [chatKey]);

//     // ── Socket: join room, handle messages + status + window events ───────
//     useEffect(() => {
//         if (!selectedUser?.phone_number_id || !selectedUser?.from_number) return;

//         const s    = getSocket();
//         const room = chatKey;

//         if (prevChatKeyRef.current && prevChatKeyRef.current !== room) {
//             s.emit("leave_chat", { room: prevChatKeyRef.current });
//         }
//         prevChatKeyRef.current = room;

//         function joinRoom() {
//             s.emit("join_chat", {
//                 phone_number_id: selectedUser.phone_number_id,
//                 user:            selectedUser.from_number,
//                 room,
//             });
//             console.log("🔌 Joined room:", room);
//         }

//         joinRoom();
//         s.on("connect", joinRoom);

//         // ── Incoming customer message → renews window ─────────────────────
//         function handleNewMessage(msg) {
//             console.log("📨 new_message:", msg);
//             const msgKey = `${msg.from}_${msg.phone_number_id}`;

//             // Renew window timestamp
//             setWindowMap(prev => ({ ...prev, [msgKey]: msg.created_at || new Date().toISOString() }));
//             // Clear Meta-closed flag — customer just wrote, window is open again
//             setMetaClosedMap(prev => ({ ...prev, [msgKey]: false }));
//             // Reset renew checkbox
//             setRenewChecked(prev => ({ ...prev, [msgKey]: false }));

//             setChatsMap(prev => {
//                 const prevMsgs = prev[msgKey] || [];
//                 if (msg.message_id && prevMsgs.some(m => m.message_id === msg.message_id)) return prev;
//                 return {
//                     ...prev,
//                     [msgKey]: [
//                         ...prevMsgs,
//                         {
//                             message_id:   msg.message_id,
//                             ReceivedDate: msg.created_at || new Date().toISOString(),
//                             created_at:   msg.created_at || new Date().toISOString(),
//                             MessageText:  msg.message,
//                             content:      msg.message,
//                             ChatType:     'IN',
//                             from_number:  msg.from,
//                             wa_status:    'received',
//                         }
//                     ]
//                 };
//             });
//         }

//         // ── window_opened (backend emits when incoming message saved) ─────
//         function handleWindowOpened(data) {
//             console.log("🔓 window_opened:", data);
//             const msgKey = `${data.recipient_id}_${data.phone_number_id}`;

//             const existing = windowMap[msgKey];
        
//             if (!existing) {
//                 // First message ever → start window
//                 setWindowMap(prev => ({
//                     ...prev,
//                     [msgKey]: data.last_customer_message_at
//                 }));
//                 return;
//             }
        
//             const diff = Date.now() - new Date(existing).getTime();
        
//             // ✅ Only reset if previous window EXPIRED
//             if (diff > 24 * 60 * 60 * 1000) {
//                 setWindowMap(prev => ({
//                     ...prev,
//                     [msgKey]: data.last_customer_message_at
//                 }));
//             }
//             // setWindowMap(prev => ({ ...prev, [msgKey]: data.last_customer_message_at }));
//             setMetaClosedMap(prev => ({ ...prev, [msgKey]: false }));
//             setRenewChecked(prev => ({ ...prev, [msgKey]: false }));
//         }

//         // ── window_closed (Meta error 131047 confirmed by backend) ────────
//         function handleWindowClosed(data) {
//             console.log("🔒 window_closed (Meta 131047):", data);
//             const msgKey = `${data.recipient_id}_${data.phone_number_id}`;
//             // Ground truth from Meta — lock the window immediately
//             setMetaClosedMap(prev => ({ ...prev, [msgKey]: true }));
//         }

//         // ── Delivery / read status tick ───────────────────────────────────
//         function handleStatus(data) {
//             console.log("📩 message_status:", data);
//             const msgKey = `${data.recipient_id}_${data.phone_number_id}`;
//             setChatsMap(prev => {
//                 const msgs = prev[msgKey]; if (!msgs) return prev;
//                 return { ...prev, [msgKey]: msgs.map(m => m.message_id === data.message_id ? { ...m, wa_status: data.status } : m) };
//             });
//             setAllDbChats(prev => {
//                 const msgs = prev[msgKey]; if (!msgs) return prev;
//                 return { ...prev, [msgKey]: msgs.map(m => m.message_id === data.message_id ? { ...m, status: data.status, wa_status: data.status } : m) };
//             });
//         }

//         s.on("new_message",    handleNewMessage);
//         s.on("window_opened",  handleWindowOpened);
//         s.on("window_closed",  handleWindowClosed);
//         s.on("message_status", handleStatus);

//         return () => {
//             s.off("connect",        joinRoom);
//             s.off("new_message",    handleNewMessage);
//             s.off("window_opened",  handleWindowOpened);
//             s.off("window_closed",  handleWindowClosed);
//             s.off("message_status", handleStatus);
//         };
//         // eslint-disable-next-line
//     }, [chatKey]);

//     // Auto scroll
//     useEffect(() => {
//         chatListEndRef.current?.scrollIntoView({ behavior: "smooth" });
//     }, [chatKey, chatsMap, allDbChats]);


//     // handle file and emoji pickup 
   
  

//     // ── Send message ──────────────────────────────────────────────────────

//     // Window is 'fresh' if last customer message was < 24hrs ago
//     const windowFresh      = windowStartAt && (Date.now() - new Date(windowStartAt).getTime()) < 86400000;
//     const needsRenewAck    = expired && windowFresh && !metaClosed && !(renewChecked[chatKey]);
//     const effectiveCanSend = canSend || (!metaClosed && windowFresh && (renewChecked[chatKey] || false));

//     const sendMessage = async () => {
//         if (!newMessage.trim() || !effectiveCanSend) return;

//         const tempId  = `temp_${Date.now()}`;
//         const sentAt  = new Date().toISOString();
//         const msgText = newMessage;

//         setChatsMap(prev => ({
//             ...prev,
//             [chatKey]: [
//                 ...(prev[chatKey] || []),
//                 {
//                     message_id:  tempId,
//                     ReceivedDate: sentAt,
//                     created_at:  sentAt,
//                     MessageText: msgText,
//                     content:     msgText,
//                     ChatType:    'OUT',
//                     from_number: null,
//                     wa_status:   'sending',
//                     temp:        true,
//                 }
//             ]
//         }));
//         setNewMessage('');

//         try {
//             const res    = await fetch("https://wa-api.globebot.io/auth/send-message", {
//                 method:  "POST",
//                 headers: { "Content-Type": "application/json", "Authorization": `Bearer ${accessToken || ""}` },
//                 body:    JSON.stringify({
//                     phone_number_id: selectedUser.phone_number_id,
//                     to:              selectedUser.from_number,
//                     message:         msgText,
//                     access_token:    accessToken,
//                 })
//             });
//             const result = await res.json();
//             const realId = result?.message_id;
//             if (realId) {
//                 setChatsMap(prev => ({
//                     ...prev,
//                     [chatKey]: (prev[chatKey] || []).map(m =>
//                         m.message_id === tempId ? { ...m, message_id: realId, wa_status: 'sent', temp: false } : m
//                     )
//                 }));
//             }
//         } catch (err) {
//             console.error("Send failed:", err);
//             setChatsMap(prev => ({
//                 ...prev,
//                 [chatKey]: (prev[chatKey] || []).map(m =>
//                     m.message_id === tempId ? { ...m, wa_status: 'failed' } : m
//                 )
//             }));
//         }
//     };

//     // ── Merged messages ───────────────────────────────────────────────────
//     const dbMsgs     = allDbChats[chatKey] || [];
//     const uiMsgs     = chatsMap[chatKey]   || [];
//     const chatsArray = getCombinedMessages(dbMsgs, uiMsgs);

//     // ── Derived ───────────────────────────────────────────────────────────
//     const safeProfileName = getProfileName(selectedUser);
//     const safeWANumber    = getWANumber(selectedUser);
//     const firstMessage    = chatsArray[0];
//     const lastMessage     = chatsArray[chatsArray.length - 1];
//     const safeLastUserMsg = selectedUser?.LastUserMessage || selectedUser?.lastMessage
//         || lastMessage?.MessageText || lastMessage?.content || lastMessage?.message || "";
//     const safeTimePassed  = selectedUser?.TimePassed || "";

//     function deduceChatType(chat) {
//         if (chat.ChatType) return chat.ChatType;
//         return isDbMessageIncoming(chat, selectedUser) ? 'IN' : 'OUT';
//     }

//     function formatDisplayDate(v) {
//         if (!v) return '';
//         try { const d = new Date(v); return isNaN(d) ? String(v) : d.toLocaleString(); } catch { return String(v); }
//     }

//     function formatDateLabel(date) {
//         if (!date) return '';
//         const d = new Date(date), today = new Date(), yesterday = new Date();
//         yesterday.setDate(today.getDate() - 1);
//         if (d.toDateString() === today.toDateString())     return "Today";
//         if (d.toDateString() === yesterday.toDateString()) return "Yesterday";
//         return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
//     }

//     const formatTime = (date) => {
//         if (!date) return '';
//         try { const d = new Date(date); return isNaN(d) ? String(date) : d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }); }
//         catch { return String(date); }
//     };

//     const formattedLastTime = lastMessage
//         ? formatDisplayDate(lastMessage.created_at || lastMessage.ReceivedDate)
//         : formatDisplayDate(selectedUser?.lastTime || selectedUser?.last_message_time || "");

//     function countdownColor() {
//         if (!timeLeft || expired) return '#ed5050';
//         const [h] = timeLeft.split(':').map(Number);
//         return h < 2 ? '#f59e0b' : '#448c74';
//     }

//     function getTime() {
//         const now = new Date();
//         let h = now.getHours(); const ampm = h >= 12 ? 'PM' : 'AM'; h = h % 12 || 12;
//         return `${String(now.getMonth()+1).padStart(2,'0')}/${String(now.getDate()).padStart(2,'0')}/${now.getFullYear()} ${String(h).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}${ampm}`;
//     }

//     // ── Notes ─────────────────────────────────────────────────────────────
//     const [AssignAgent, setAssignAgent] = useState(false);
//     const [Notes,       setNotes]       = useState(false);
//     const [Customer,    setCustomer]    = useState(false);
//     const [Notestext,   setNotestext]   = useState('');
//     const [AddNotes,    setAddNotes]    = useState([]);
//     const [open,        setOpen]        = useState(false);
//     const [editId,      setEditId]      = useState(null);

//     function addNotes() {
//         if (!Notestext.trim()) return;
//         if (editId) {
//             setAddNotes(prev => prev.map(item => item.id === editId ? { ...item, text: Notestext } : item));
//             setEditId(null);
//         } else {
//             setAddNotes(prev => [...prev, { id: Date.now(), text: Notestext, time: getTime() }]);
//         }
//         setNotestext(''); setOpen(false);
//     }
//     const deleteNote = (id) => setAddNotes(prev => prev.filter(item => item.id !== id));

//     // ─────────────────────────────────────────────────────────────────────
//     // Renew window: agent checks the checkbox confirming they've seen the
//     // customer's new message and want to open the window.
//     // The window was already renewed by the incoming socket message —
//     // the checkbox is just a UI gate so agents don't accidentally send.
//     // const renewChecked[chatKey] = renewChecked[chatKey] || false;
    
//     return (
//         <>
//             <div className='w-[100%] flex h-auto'>

//                 {/* ══════════════ CHAT PANEL ══════════════ */}
//                 <div
//                     style={{ backgroundImage: `url(${chatBg})`, height: '600px' }}
//                     className='w-[60%] bg-cover bg-center flex flex-col'
//                 >
//                     {/* Header */}
//                     <div className='w-[100%] border-[#e3e9ef] border-b-[1px] py-2 px-4 flex gap-4 items-center justify-between bg-white shrink-0'>
//                         <div className='flex gap-4 items-center'>
//                             <div className='w-[55px] h-[55px] bg-[#0000000d] rounded-full flex justify-center items-center text-[24px] uppercase font-semibold text-[#576071]'>
//                                 {safeProfileName.slice(0, 2)}
//                             </div>
//                             <div>
//                                 <h3 className='text-[#000] text-[15px] font-bold capitalize'>{safeProfileName}</h3>
//                                 <h3 className='text-[#858c97] text-[13px] font-semibold'>{safeWANumber}</h3>
//                             </div>
//                         </div>

//                         {/* 24hr countdown badge */}
//                         {windowStartAt ? (
//                             <div
//                                 style={{ backgroundColor: countdownColor() }}
//                                 className='flex flex-col items-center px-3 py-1 rounded-lg text-white min-w-[110px] transition-all duration-500'
//                             >
//                                 <span className='text-[9px] font-bold uppercase tracking-wider'>
//                                     {expired ? 'Window Closed' : '24hr Window'}
//                                 </span>
//                                 <span className='text-[15px] font-bold font-mono tracking-widest'>{timeLeft}</span>
//                             </div>
//                         ) : (
//                             <div className='flex flex-col items-center px-3 py-1 rounded-lg bg-gray-200 text-gray-500 min-w-[110px]'>
//                                 <span className='text-[9px] font-bold uppercase tracking-wider'>No Window</span>
//                                 <span className='text-[11px] font-semibold'>Awaiting msg</span>
//                             </div>
//                         )}
//                     </div>

//                     {/* Messages */}
//                     <div className='flex-1 overflow-y-auto px-2 py-2'>
//                         {chatsArray.length > 0 ? (
//                             chatsArray.map((chat, index) => {
//                                 const dateStr  = chat.created_at || chat.ReceivedDate;
//                                 const prevDate = index > 0
//                                     ? new Date(chatsArray[index-1].created_at || chatsArray[index-1].ReceivedDate).toDateString()
//                                     : null;
//                                 const showDate = !prevDate || new Date(dateStr).toDateString() !== prevDate;
//                                 const chatType = deduceChatType(chat);
//                                 const msgText  = chat.MessageText || chat.content || chat.message || "";
//                                 const msgStatus = chat.wa_status || chat.status;

//                                 return (
//                                     <div className='w-[100%]' key={chat.message_id || chat.id || dateStr || index}>
//                                         {showDate && (
//                                             <div className="text-center my-3">
//                                                 <span className="bg-gray-200 text-xs px-3 py-1 rounded-full font-bold text-[#434a57]">
//                                                     {formatDateLabel(dateStr)}
//                                                 </span>
//                                             </div>
//                                         )}

//                                         {chatType === 'IN' ? (
//                                             <div className='flex gap-2 justify-start mb-3'>
//                                                 <div className='w-[44px] h-[44px] bg-[#3f7fca26] rounded-full flex justify-center items-center text-[16px] uppercase font-semibold text-[#3f7fca] shrink-0'>
//                                                     {safeProfileName.slice(0, 2)}
//                                                 </div>
//                                                 <div className='max-w-[65%]'>
//                                                     <div className='bg-[#3f80ca15] p-3 text-[13px] font-semibold text-[#121519d1] rounded-t-[20px] rounded-r-[20px] rounded-bl-none'>
//                                                         {msgText}
//                                                     </div>
//                                                     <p className='text-[#858c97] text-[11px] font-semibold mt-1'>{formatTime(dateStr)}</p>
//                                                 </div>
//                                             </div>
//                                         ) : (
//                                             <div className='w-[100%] mb-3'>
//                                                 <div className="flex justify-center items-center my-1">
//                                                     <span className="bg-gray-200 text-xs px-3 py-1 rounded-full font-bold text-[#434a57]">
//                                                         service message sent
//                                                     </span>
//                                                 </div>
//                                                 <div className='flex gap-2 justify-end items-end'>
//                                                     <div className='max-w-[65%]'>
//                                                         <div className='bg-[#448c74] p-3 text-[13px] font-semibold text-white rounded-t-[20px] rounded-l-[20px] rounded-br-none flex items-end gap-2'>
//                                                             <span>{msgText}</span>
//                                                             <MessageTick status={msgStatus} />
//                                                         </div>
//                                                         <p className='text-[#858c97] text-[11px] font-semibold text-end mt-1'>{formatTime(dateStr)}</p>
//                                                     </div>
//                                                     <img className='w-[44px] h-[44px] shrink-0' src={SenderIcon} alt="" />
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 );
//                             })
//                         ) : (
//                             <div className='text-center text-gray-400 p-10'>No chat history available.</div>
//                         )}
//                         <div ref={chatListEndRef} />
//                     </div>

//                     {/* ── Input area ── */}
//                     <div className="w-full flex flex-col p-2 border-t bg-white shrink-0">

//                         {/* Case 1: No window at all — never received a message */}
//                         {!windowStartAt && (
//                             <div className='w-full text-center text-[12px] text-[#858c97] font-semibold mb-2 bg-[#f6f9fc] py-2 rounded-lg border border-[#ddd]'>
//                                 💬 Waiting for the customer to send a message first to open the 24hr window.
//                             </div>
//                         )}

//                         {/* Case 2: Window expired, customer has sent a NEW message (windowFresh) — show renew checkbox */}
//                         {needsRenewAck && (
//                             <div className='w-full mb-2 bg-[#fffbe6] border border-[#f59e0b] rounded-lg px-3 py-2 flex items-start gap-2'>
//                                 <input
//                                     type="checkbox"
//                                     id={`renew_${chatKey}`}
//                                     checked={renewChecked[chatKey]}
//                                     onChange={(e) => setRenewChecked(prev => ({ ...prev, [chatKey]: e.target.checked }))}
//                                     className='mt-[3px] w-[15px] h-[15px] accent-[#448c74] cursor-pointer shrink-0'
//                                 />
//                                 <label htmlFor={`renew_${chatKey}`} className='text-[12px] text-[#856404] font-semibold cursor-pointer leading-snug'>
//                                     Customer sent a new message — tick to re-open the 24hr messaging window and reply.
//                                 </label>
//                             </div>
//                         )}

//                         {/* Case 3: Window expired, customer has NOT sent any message — fully blocked */}
//                         {expired && !windowFresh && windowStartAt && (
//                             <div className='w-full text-center text-[12px] text-[#ed5050] font-semibold mb-2 bg-[#fff0f0] py-2 rounded-lg border border-[#ed5050]'>
//                                 ⛔ 24-hr window closed. You can only send template messages until the customer replies.
//                             </div>
//                         )}

//                         <div className='flex'>
//                             <input
//                                 type="text"
//                                 value={newMessage}
//                                 onChange={(e) => setNewMessage(e.target.value)}
//                                 onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
//                                 placeholder={
//                                     !windowStartAt            ? "Waiting for customer to message first..." :
//                                     needsRenewAck             ? "Tick the checkbox above to enable reply..." :
//                                     (expired && !windowFresh) ? "Window closed — use a template message..." :
//                                                                 "Type a message..."
//                                 }
//                                 disabled={!effectiveCanSend}
//                                 className={`flex-1 border rounded-lg px-3 py-2 outline-none text-[13px] transition-colors ${
//                                     !effectiveCanSend ? 'bg-gray-100 cursor-not-allowed text-gray-400' : 'bg-white'
//                                 }`}
//                             />
//                             <button
//                                 onClick={sendMessage}
//                                 disabled={!effectiveCanSend}
//                                 className={`ml-2 px-4 rounded-lg text-white font-semibold text-[13px] transition-colors ${
//                                     !effectiveCanSend ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#128C7E] hover:bg-[#075E54]'
//                                 }`}
//                             >
//                                 Send
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* ══════════════ RIGHT PANEL ══════════════ */}
//                 <div className='w-[40%] p-6 bg-[#fff] min-h-screen overflow-y-auto'>
//                     <div className='w-[100%] rounded-lg'>
//                         <div className='w-[100%] flex gap-2 bg-gradient-to-br from-[#075E54] to-[#128C7E] p-6 rounded-t-[20px] items-center'>
//                             <div className='w-[50px] h-[50px] bg-[#ada426] rounded-lg flex justify-center items-center text-[20px] uppercase font-semibold text-white shrink-0'>
//                                 {safeProfileName.slice(0, 2)}
//                             </div>
//                             <div className='flex-1 min-w-0'>
//                                 <h1 className='text-[15px] text-white font-semibold truncate'>{safeProfileName}</h1>
//                                 <h1 className='text-[13px] text-white'>{safeWANumber}</h1>
//                             </div>
//                             <div className='text-[13px] text-white font-semibold flex items-center gap-1 cursor-pointer shrink-0'>
//                                 <LuSquareArrowOutUpRight /> Export Chat
//                             </div>
//                         </div>

//                         <div className='bg-[#e5ddd536] w-[100%] p-4'>
//                             <div className='flex items-center justify-between w-[100%]'>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold'>Last Message On</span>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold'>{formattedLastTime || 'N/A'}</span>
//                             </div>
//                             <div className='flex items-center justify-between w-[100%] mt-2'>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold'>Last Active</span>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold'>{safeTimePassed}</span>
//                             </div>
//                             <div className='flex items-center justify-between w-[100%] mt-2'>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold'>Last Message</span>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold truncate max-w-[55%]'>{safeLastUserMsg}</span>
//                             </div>

//                             {/* Window status in right panel */}
//                             <div className='flex items-center justify-between w-[100%] mt-2 border-t border-[#ddd] pt-2'>
//                                 <span className='text-[#576071e0] text-[13px] font-semibold'>Msg Window</span>
//                                 <span
//                                     style={{ color: countdownColor() }}
//                                     className='text-[13px] font-bold font-mono'
//                                 >
//                                     {!windowStartAt ? '—' : expired ? 'Closed' : timeLeft}
//                                 </span>
//                             </div>

//                             <div className='w-[100%] mt-6'>
//                                 <span className='text-[18px] text-[#448c74] flex font-semibold items-center gap-1'>
//                                     Actions <FaArtstation />
//                                 </span>
//                             </div>
//                             <div className='w-[100%] border-[#000] border-t-[1px]'>
//                                 <button className='flex items-center justify-center gap-2 w-[100%] p-3 text-white font-bold text-[14px] bg-[#ed5050] hover:bg-[#e92b2b] rounded-lg mt-3'>
//                                     <MdBlock /> Block {safeProfileName}
//                                 </button>

//                                 {/* Assign Agent */}
//                                 <div className='bg-[#f6f9fc] border-[#ddd] border rounded-lg mt-2'>
//                                     <div onClick={() => setAssignAgent(!AssignAgent)}
//                                         className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer p-2 rounded-t-lg ${AssignAgent ? 'bg-[#edf1f5]' : ''}`}>
//                                         Assign Agent {AssignAgent ? <IoIosArrowUp /> : <IoIosArrowDown />}
//                                     </div>
//                                     {AssignAgent && (
//                                         <div className='flex flex-wrap gap-1 p-2'>
//                                             {['Gurpreet', 'Abiee', 'Pradeep'].map(name => (
//                                                 <button key={name} className='border border-[#448c74] rounded-lg p-2 hover:bg-[#448c74] text-[#448c74] hover:text-white text-[12px] font-semibold'>
//                                                     {name}
//                                                 </button>
//                                             ))}
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* Notes */}
//                                 <div className='bg-[#f6f9fc] border-[#ddd] border rounded-lg mt-2'>
//                                     <div onClick={() => setNotes(!Notes)}
//                                         className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer p-2 rounded-t-lg ${Notes ? 'bg-[#edf1f5]' : ''}`}>
//                                         Notes {Notes ? <IoIosArrowUp /> : <IoIosArrowDown />}
//                                     </div>
//                                     {Notes && (
//                                         <div className='mt-2 p-2'>
//                                             <button onClick={() => setOpen(true)}
//                                                 className='border border-[#448c74] rounded-lg p-2 bg-[#448c74] text-white text-[12px] font-semibold'>
//                                                 <MdAdd />
//                                             </button>
//                                             {AddNotes.length > 0 ? AddNotes.map(item => (
//                                                 <div className='w-[100%] mt-2' key={item.id}>
//                                                     <div className='w-[100%] bg-[#fff9db] p-2 rounded'>
//                                                         <div className='flex justify-between gap-2 items-center'>
//                                                             <div className='w-[32px] h-[32px] rounded-full bg-[#eee] flex justify-center items-center shrink-0'>
//                                                                 <FaUser />
//                                                             </div>
//                                                             <div className='flex-1 min-w-0'>
//                                                                 <h1 className='text-[#576071] text-[12px] font-semibold truncate'>{safeProfileName}</h1>
//                                                                 <h1 className='text-[#576071] text-[11px]'>{item.time}</h1>
//                                                             </div>
//                                                             <div className='flex gap-1 shrink-0'>
//                                                                 <button onClick={() => { setEditId(item.id); setOpen(true); setNotestext(item.text); }}
//                                                                     className='p-1.5 border border-[#448c74] rounded-md text-[#448c74] hover:text-white hover:bg-[#448c74]'>
//                                                                     <FaEdit size={12} />
//                                                                 </button>
//                                                                 <button onClick={() => deleteNote(item.id)}
//                                                                     className='p-1.5 border border-[#ed5050] rounded-md text-[#ed5050] hover:text-white hover:bg-[#ed5050]'>
//                                                                     <MdDelete size={12} />
//                                                                 </button>
//                                                             </div>
//                                                         </div>
//                                                         <p className='text-[12px] text-[#576071] font-semibold mt-2'>{item.text}</p>
//                                                     </div>
//                                                 </div>
//                                             )) : (
//                                                 <p className='w-[100%] text-center text-[#858c97] text-[13px] mt-2'>No notes available</p>
//                                             )}
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* Customer Journey */}
//                                 <div className='bg-[#f6f9fc] border-[#ddd] border rounded-lg mt-2'>
//                                     <div onClick={() => setCustomer(!Customer)}
//                                         className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer p-2 rounded-t-lg ${Customer ? 'bg-[#edf1f5]' : ''}`}>
//                                         Customer Journey {Customer ? <IoIosArrowUp /> : <IoIosArrowDown />}
//                                     </div>
//                                     {Customer && (
//                                         <div className='flex pb-4 px-3 pt-3 gap-3'>
//                                             <div className='flex flex-col items-center gap-1'>
//                                                 <div className='w-[10px] h-[10px] bg-[#000] rounded-full'></div>
//                                                 <div className='w-[1px] h-[30px] bg-[#000]'></div>
//                                             </div>
//                                             <div>
//                                                 <h5 className='text-[#576071] text-[12px] font-bold'>User Created</h5>
//                                                 <h5 className='text-[#576071] text-[11px]'>
//                                                     {firstMessage ? formatTime(firstMessage.created_at || firstMessage.ReceivedDate) : '—'}
//                                                 </h5>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Notes Modal */}
//             <AddNotesModal isOpen={open} onClose={() => { setOpen(false); setNotestext(''); setEditId(null); }} heading={editId ? 'Edit Note' : 'Add Note'}>
//                 <textarea
//                     className='border border-[#d4cfcf] w-[100%] rounded-lg outline-none mt-4 p-2'
//                     placeholder='Write your note...'
//                     rows={4}
//                     value={Notestext}
//                     onChange={(e) => setNotestext(e.target.value)}
//                 />
//                 <div className='w-[100%] flex items-center justify-end mt-4 gap-2'>
//                     <button onClick={() => { setOpen(false); setNotestext(''); setEditId(null); }}
//                         className='bg-[#edf1f5] hover:bg-[#d3dde6] text-[14px] font-semibold p-2 rounded-lg'>Cancel</button>
//                     <button onClick={addNotes}
//                         className='bg-[#3fca90] hover:bg-[#31b07b] text-[14px] text-white font-semibold p-2 rounded-lg'>Save</button>
//                 </div>
//             </AddNotesModal>
//         </>
//     );
// }

// export default Whatapplivechat;

import React, { useState, useEffect, useRef } from 'react'
import chatBg from '../images/bg-pattern-liveAgent.png'
import SenderIcon from '../images/callericon.png'
import { LuSquareArrowOutUpRight } from "react-icons/lu";
import { FaArtstation } from "react-icons/fa";
import { MdBlock } from "react-icons/md";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdAdd } from "react-icons/md";
import { FaUser, FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import AddNotesModal from './Addnotes';
import { io as socketIOClient } from "socket.io-client";
import * as XLSX from 'xlsx';

// ── Singleton socket ──
let socket = null;
function getSocket() {
    if (!socket) {
        // Check first for polling transport for better cross-browser compatibility
        socket = socketIOClient("https://wa-api.globebot.io", {
            transports: ["websocket", "polling"], // Prefer websocket, fallback to polling
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 1000,
            timeout: 20000, // 20 seconds
            autoConnect: true,
        });
        // Debug: Log socket connection/disconnect
        socket.on("connect", () => {
            // eslint-disable-next-line no-console
            console.log("[Socket] Connected with id", socket.id);
        });
        socket.on("disconnect", (reason) => {
            // eslint-disable-next-line no-console
            console.warn("[Socket] Disconnected:", reason);
        });
        socket.on("connect_error", (err) => {
            // eslint-disable-next-line no-console
            console.error("[Socket] Connection error:", err);
        });
        socket.on("error", (err) => {
            // eslint-disable-next-line no-console
            console.error("[Socket] General socket error:", err);
        });
    }
    return socket;
}

function getProfileName(user) {
    return user?.messages && user?.messages[0]?.profileName
        ? user.messages[0].profileName
        : user?.name || user?.from_number || "";
}
function getWANumber(user) {
    return user?.WANumber || user?.from_number || "";
}
function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64).split('').map(c =>
                '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            ).join('')
        );
        return JSON.parse(jsonPayload);
    } catch { return {}; }
}
function getUserIdFromToken() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
    }
    return { userId: null, token: null };
}
function isDbMessageIncoming(msg, selectedUser) {
    if (!selectedUser?.from_number) return false;
    if (msg.from_number && msg.from_number === selectedUser.from_number) return true;
    if (!msg.from_number) return false;
    return false;
}
function getCombinedMessages(dbMsgs, uiMsgs) {
    dbMsgs = Array.isArray(dbMsgs) ? dbMsgs : [];
    uiMsgs = Array.isArray(uiMsgs) ? uiMsgs : [];
    const msgMap = {};
    dbMsgs.forEach(msg => {
        const id = msg.message_id || msg.id || msg.created_at;
        if (id) msgMap[id] = { ...msg };
    });
    uiMsgs.forEach(msg => {
        const id = msg.message_id || msg.id || msg.ReceivedDate;
        if (id) msgMap[id] = { ...(msgMap[id] || {}), ...msg };
    });
    return Object.values(msgMap).sort((a, b) =>
        new Date(a.created_at || a.ReceivedDate) - new Date(b.created_at || b.ReceivedDate)
    );
}
function renderMessageContent(text, isOutgoing = false) {
    if (!text) return '';
    try {
        const parsed = typeof text === 'string' ? JSON.parse(text) : text;
        if (parsed?.name && parsed?.language !== undefined) {
            const headerComp  = parsed.components?.find(c => (c.type || '').toLowerCase() === 'header');
            const bodyComp    = parsed.components?.find(c => (c.type || '').toLowerCase() === 'body');
            const footerComp  = parsed.components?.find(c => (c.type || '').toLowerCase() === 'footer');
            const buttonsComp = parsed.components?.find(c => (c.type || '').toLowerCase() === 'buttons');
            const params = bodyComp?.parameters || [];
            let bodyText = bodyComp?.text || '';
            params.forEach((param, i) => {
                bodyText = bodyText.replace(
                    new RegExp(`\\{\\{${i + 1}\\}\\}`, 'g'),
                    param.text || param.payload || ''
                );
            });
            const badgeBg   = isOutgoing ? 'bg-[#ffffff25]' : 'bg-[#448c7420]';
            const badgeText = isOutgoing ? 'text-[#d4f1e8]'  : 'text-[#448c74]';
            const divider   = isOutgoing ? 'border-[#ffffff30]' : 'border-[#c8e6dc]';
            const btnClr    = isOutgoing ? 'text-[#d4f1e8]'  : 'text-[#448c74]';
            const footerClr = isOutgoing ? 'text-[#ffffffa0]' : 'text-[#858c97]';
            return (
                <div className='flex flex-col gap-1 min-w-[160px]'>
                    <div className='flex items-center gap-1.5 mb-0.5'>
                        <span className={`text-[10px] ${badgeBg} ${badgeText} px-2 py-0.5 rounded-full font-bold uppercase tracking-wide`}>
                            Template
                        </span>
                        <span className={`text-[10px] ${footerClr} font-semibold truncate max-w-[140px]`}>
                            {parsed.name}
                        </span>
                    </div>
                    {headerComp?.text && (
                        <p className='font-bold text-[13px] leading-snug'>{headerComp.text}</p>
                    )}
                    {bodyText ? (
                        <p className='text-[13px] leading-snug whitespace-pre-wrap'>{bodyText}</p>
                    ) : params.length > 0 ? (
                        <p className='text-[13px] leading-snug'>
                            {params.map(p => p.text || p.payload).filter(Boolean).join(' · ')}
                        </p>
                    ) : (
                        <p className='text-[13px] italic opacity-75'>{parsed.name}</p>
                    )}
                    {footerComp?.text && (
                        <p className={`text-[10px] ${footerClr} mt-0.5`}>{footerComp.text}</p>
                    )}
                    {buttonsComp?.buttons?.length > 0 && (
                        <div className={`mt-1 pt-1 border-t ${divider} flex flex-col gap-0.5`}>
                            {buttonsComp.buttons.map((btn, i) => (
                                <span key={i} className={`text-[12px] ${btnClr} font-semibold text-center`}>
                                    {btn.text}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            );
        }
    } catch { }
    return <span className='whitespace-pre-wrap'>{text}</span>;
}
function MessageTick({ status }) {
    if (!status || status === 'sending')
        return <span className="text-white opacity-50 text-[11px] ml-1">⏳</span>;
    if (status === 'sent')
        return <span className="text-white opacity-70 text-[11px] ml-1">✓</span>;
    if (status === 'delivered')
        return <span className="text-white opacity-70 text-[11px] font-bold ml-1">✓✓</span>;
    if (status === 'read')
        return <span className="text-[#53bdeb] text-[11px] font-bold ml-1">✓✓</span>;
    return null;
}
function use24hrCountdown(windowStartAt) {
    const [timeLeft, setTimeLeft] = useState(null);
    const [expired,  setExpired]  = useState(true);
    useEffect(() => {
        if (!windowStartAt) {
            setTimeLeft(null);
            setExpired(true);
            return;
        }
        function calc() {
            const deadline = new Date(windowStartAt).getTime() + 24 * 60 * 60 * 1000;
            const diff     = deadline - Date.now();
            if (diff <= 0) {
                setExpired(true);
                setTimeLeft("00:00:00");
                return false;
            }
            setExpired(false);
            const h = Math.floor(diff / 3600000);
            const m = Math.floor((diff % 3600000) / 60000);
            const s = Math.floor((diff % 60000) / 1000);
            setTimeLeft(
                `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`
            );
            return true;
        }
        if (!calc()) return;
        const iv = setInterval(() => { if (!calc()) clearInterval(iv); }, 1000);
        return () => clearInterval(iv);
    }, [windowStartAt]);
    return { timeLeft, expired };
}

// ====================================
// Main component
// ====================================
function Whatapplivechat({ selectedUser }) {
    const { userId } = getUserIdFromToken();

    const chatKey = selectedUser?.from_number && selectedUser?.phone_number_id
        ? `${selectedUser.from_number}_${selectedUser.phone_number_id}`
        : 'unknown';

    const [accessToken,   setAccessToken]   = useState(null);
    const [allDbChats,    setAllDbChats]    = useState({});
    const [chatsMap,      setChatsMap]      = useState({});
    const [newMessage,    setNewMessage]    = useState('');
    const [windowMap,     setWindowMap]     = useState({});
    const [metaClosedMap, setMetaClosedMap] = useState({});
    const [renewChecked,  setRenewChecked]  = useState({});

    const chatListEndRef = useRef(null);
    const prevChatKeyRef = useRef(null);

    const windowStartAt = windowMap[chatKey]     || null;
    const metaClosed    = metaClosedMap[chatKey]  || false;
    const { timeLeft, expired: timerExpired } = use24hrCountdown(windowStartAt);

    const expired    = metaClosed || timerExpired;

    const [agents,            setAgents           ] = useState([]);
    const [agentsLoading,     setAgentsLoading    ] = useState(false);
    const [selectedAgentId,   setSelectedAgentId  ] = useState(null);
    const [currentAssignment, setCurrentAssignment] = useState(null);
    const [assigning,         setAssigning        ] = useState(false);

    useEffect(() => {
        if (!userId || !accessToken) return;
        setAgentsLoading(true);
        setAssignError('');
        fetch(`https://wa-api.globebot.io/auth/agents/by-account?user_id=${userId}`, {
            headers: { 'Authorization': `Bearer ${accessToken}` }
        })
            .then(r => r.json())
            .then(data => {
                if (data.success) setAgents(data.data || []);
                else setAgents([]);
            })
            .catch(() => setAgents([]))
            .finally(() => setAgentsLoading(false));
    }, [userId, accessToken]);

    useEffect(() => {
        if (!selectedUser?.phone_number_id || !selectedUser?.from_number || !accessToken) return;
        fetch(
            `https://wa-api.globebot.io/auth/chat-assignment?phone_number_id=${encodeURIComponent(selectedUser.phone_number_id)}&customer_number=${encodeURIComponent(selectedUser.from_number)}`,
            { headers: { 'Authorization': `Bearer ${accessToken}` } }
        )
            .then(r => r.json())
            .then(data => {
                if (data.success && data.data?.status === 'assigned') {
                    setCurrentAssignment(data.data);
                    setSelectedAgentId(data.data.agent_id);
                } else {
                    setCurrentAssignment(null);
                    setSelectedAgentId(null);
                }
            })
            .catch(() => {
                setCurrentAssignment(null);
                setSelectedAgentId(null);
            });
    }, [selectedUser?.phone_number_id, selectedUser?.from_number, accessToken]);

    useEffect(() => {
        setCurrentAssignment(null);
        setSelectedAgentId(null);
        setAssignError('');
        setAssigning(false);
    }, [selectedUser]);

    async function handleAssign() {
        if (!selectedAgentId || !selectedUser?.phone_number_id || !selectedUser?.from_number) return;
        setAssigning(true);
        setAssignError('');
        try {
            const res  = await fetch('https://wa-api.globebot.io/auth/assign-chat', {
                method:  'POST',
                headers: { 'Authorization': `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
                body:    JSON.stringify({
                    phone_number_id:  selectedUser.phone_number_id,
                    customer_number:  selectedUser.from_number,
                    agent_id:         selectedAgentId,
                    assigned_by:      userId
                })
            });
            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.error || 'Assignment failed');
            const agent = agents.find(a => a.id === selectedAgentId);
            setCurrentAssignment({
                agent_id:    selectedAgentId,
                agent_name:  agent?.name || data.agent_name || 'Agent',
                status:      'assigned',
                assigned_at: new Date().toISOString()
            });
        } catch (e) {
            setAssignError(e.message || 'Assignment failed');
        } finally {
            setAssigning(false);
        }
    }

    async function handleUnassign() {
        if (!selectedUser?.phone_number_id || !selectedUser?.from_number) return;
        setAssigning(true);
        setAssignError('');
        try {
            const res  = await fetch('https://wa-api.globebot.io/auth/unassign-chat', {
                method:  'POST',
                headers: { 'Authorization': `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
                body:    JSON.stringify({
                    phone_number_id: selectedUser.phone_number_id,
                    customer_number: selectedUser.from_number
                })
            });
            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.error || 'Unassign failed');
            setCurrentAssignment(null);
            setSelectedAgentId(null);
        } catch (e) {
            setAssignError(e.message || 'Unassign failed');
        } finally {
            setAssigning(false);
        }
    }

    const isAssigned  = currentAssignment?.status === 'assigned' && currentAssignment?.agent_id;
    const stagedAgent = agents.find(a => a.id === selectedAgentId);
    const canSend     = !metaClosed && (userId || (selectedAgentId && selectedAgentId !== currentAssignment?.agent_id));

    useEffect(() => {
        if (!userId) { setAccessToken(null); return; }
        fetch(`https://wa-api.globebot.io/auth/access_token?user_id=${encodeURIComponent(userId)}`)
            .then(r => r.json())
            .then(data => setAccessToken(Array.isArray(data.access_token) ? data.access_token[0] : null))
            .catch(() => setAccessToken(null));
    }, [userId]);

    useEffect(() => {
        if (!selectedUser?.phone_number_id || !selectedUser?.from_number) return;
        fetch(
            `https://wa-api.globebot.io/auth/messages/${encodeURIComponent(selectedUser.phone_number_id)}/${encodeURIComponent(selectedUser.from_number)}`
        )
            .then(r => { if (r.status === 404) return []; if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
            .then(data => {
                const msgs   = Array.isArray(data) ? data : [];
                const sorted = [...msgs].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
                setAllDbChats(prev => ({ ...prev, [chatKey]: sorted }));
            })
            .catch(() => {});
        fetch(
            `https://wa-api.globebot.io/auth/window-status?phone_number_id=${encodeURIComponent(selectedUser.phone_number_id)}&customer_number=${encodeURIComponent(selectedUser.from_number)}`
        )
            .then(r => r.json())
            .then(data => {
                if (data.last_customer_message_at) {
                    setWindowMap(prev => {
                        const existing = prev[chatKey];
                        if (!existing) {
                            return {
                                ...prev,
                                [chatKey]: data.last_customer_message_at
                            };
                        }
                        const existingTime = new Date(existing).getTime();
                        const apiTime = new Date(data.last_customer_message_at).getTime();
                        return {
                            ...prev,
                            [chatKey]: Math.min(existingTime, apiTime) === existingTime
                                ? existing
                                : data.last_customer_message_at
                        };
                    });
                }
                if (!data.window_open) {
                    setMetaClosedMap(prev => ({ ...prev, [chatKey]: true }));
                } else {
                    setMetaClosedMap(prev => ({ ...prev, [chatKey]: false }));
                }
            })
            .catch(() => {});
    }, [chatKey, selectedUser?.phone_number_id, selectedUser?.from_number]);

    // --- SOCKET CONNECTION & LIVE EVENT LISTENER LOGIC ---
    useEffect(() => {
        if (!selectedUser?.phone_number_id || !selectedUser?.from_number) return;

        const s    = getSocket();
        const room = chatKey;

        // In case websocket transport fails (which is currently seen from the browser/network logs), try to re-connect via polling.
        s.io.opts.transports = ["websocket", "polling"];

        // Debug connection transport mode switching
        if (s.io && s.io.engine) {
            s.io.engine.on && s.io.engine.on("upgrade", (transport) => {
                // eslint-disable-next-line no-console
                console.log("[Socket.io] Transport upgraded to", transport && transport.name);
            });
            s.io.engine.on && s.io.engine.on("close", (reason) => {
                // eslint-disable-next-line no-console
                console.warn("[Socket.io] Engine closed: ", reason);
            });
        }

        // Leave previous room if changed
        if (prevChatKeyRef.current && prevChatKeyRef.current !== room) {
            try {
                s.emit("leave_chat", { room: prevChatKeyRef.current });
            } catch (err) {
                // eslint-disable-next-line no-console
                console.warn("[Socket Leave] Error:", err);
            }
        }
        prevChatKeyRef.current = room;

        function joinRoom() {
            try {
                s.emit("join_chat", {
                    phone_number_id: selectedUser.phone_number_id,
                    user:            selectedUser.from_number,
                    room,
                });
                // eslint-disable-next-line no-console
                console.debug("[Socket] join_chat emitted to", room);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error("[Socket] join_chat emit failed", err);
            }
        }
        joinRoom();
        s.on("connect", joinRoom);

        // Listen for socket connection error and attempt fallbacks
        s.io.on && s.io.on("error", (err) => {
            // eslint-disable-next-line no-console
            console.error("[Socket.io][io.error]", err);
        });
        s.io.on && s.io.on("reconnect_error", (err) => {
            // eslint-disable-next-line no-console
            console.error("[Socket.io][reconnect_error]", err);
        });

        function handleNewMessage(msg) {
            // Defensive message key fallback
            const msgKey = (msg.from || msg.from_number || msg.recipient_id) + '_' + (msg.phone_number_id || msg.phone_id);

            setWindowMap(prev => {
                const existing = prev[msgKey];
                if (!existing) {
                    return {
                        ...prev,
                        [msgKey]: msg.created_at
                    };
                }
                const diff = Date.now() - new Date(existing).getTime();
                if (diff > 24 * 60 * 60 * 1000) {
                    return {
                        ...prev,
                        [msgKey]: msg.created_at
                    };
                }
                return prev;
            });

            setMetaClosedMap(prev => {
                const existing = prev[msgKey];
                if (existing) {
                    return {
                        ...prev,
                        [msgKey]: false
                    };
                }
                return prev;
            });

            setRenewChecked(prev => ({ ...prev, [msgKey]: false }));

            setChatsMap(prev => {
                const prevMsgs = prev[msgKey] || [];
                if (msg.message_id && prevMsgs.some(m => m.message_id === msg.message_id)) {
                    return prev;
                }
                return {
                    ...prev,
                    [msgKey]: [
                        ...prevMsgs,
                        {
                            message_id: msg.message_id,
                            ReceivedDate: msg.created_at,
                            created_at: msg.created_at,
                            MessageText: msg.message,
                            content: msg.message,
                            ChatType: 'IN',
                            from_number: msg.from || msg.from_number || msg.recipient_id,
                            wa_status: 'received',
                        }
                    ]
                };
            });
        }
        function handleWindowOpened(data) {
            const msgKey = (data.recipient_id || data.from_number || data.from) + '_' + (data.phone_number_id || data.phone_id);
            setWindowMap(prev => {
                const existing = prev[msgKey];
                if (!existing) {
                    return { ...prev, [msgKey]: data.last_customer_message_at };
                }
                const diff = new Date(data.last_customer_message_at).getTime() - new Date(existing).getTime();
                if (diff > 24 * 60 * 60 * 1000) {
                    return { ...prev, [msgKey]: data.last_customer_message_at };
                }
                return prev;
            });
            setMetaClosedMap(prev => ({ ...prev, [msgKey]: false }));
            setRenewChecked(prev => ({ ...prev, [msgKey]: false }));
        }
        function handleWindowClosed(data) {
            const msgKey = (data.recipient_id || data.from_number || data.from) + '_' + (data.phone_number_id || data.phone_id);
            setMetaClosedMap(prev => ({ ...prev, [msgKey]: true }));
        }
        function handleStatus(data) {
            const msgKey = (data.recipient_id || data.from_number || data.from) + '_' + (data.phone_number_id || data.phone_id);
            setChatsMap(prev => {
                const msgs = prev[msgKey]; if (!msgs) return prev;
                return { ...prev, [msgKey]: msgs.map(m => m.message_id === data.message_id ? { ...m, wa_status: data.status } : m) };
            });
            setAllDbChats(prev => {
                const msgs = prev[msgKey]; if (!msgs) return prev;
                return { ...prev, [msgKey]: msgs.map(m => m.message_id === data.message_id ? { ...m, status: data.status, wa_status: data.status } : m) };
            });
        }

        s.on("new_message",    handleNewMessage);
        s.on("window_opened",  handleWindowOpened);
        s.on("window_closed",  handleWindowClosed);
        s.on("message_status", handleStatus);

        // To reduce repeated reconnect attempts, listen to transport errors
        function cleanup() {
            s.off("connect",        joinRoom);
            s.off("new_message",    handleNewMessage);
            s.off("window_opened",  handleWindowOpened);
            s.off("window_closed",  handleWindowClosed);
            s.off("message_status", handleStatus);
        }
        return cleanup;
    }, [chatKey, selectedUser?.from_number, selectedUser?.phone_number_id]);

    // Auto scroll
    useEffect(() => {
        chatListEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [chatKey, chatsMap, allDbChats]);

    // ── Send message
    const windowFresh      = windowStartAt && (Date.now() - new Date(windowStartAt).getTime()) < 86400000;
    const needsRenewAck    = expired && windowFresh && !metaClosed && !(renewChecked[chatKey]);
    const effectiveCanSend = canSend || (!metaClosed && windowFresh && (renewChecked[chatKey] || false));

    const sendMessage = async () => {
        if (!newMessage.trim() || !effectiveCanSend) return;
        const tempId  = `temp_${Date.now()}`;
        const sentAt  = new Date().toISOString();
        const msgText = newMessage;
        setChatsMap(prev => ({
            ...prev,
            [chatKey]: [
                ...(prev[chatKey] || []),
                {
                    message_id:   tempId,
                    ReceivedDate: sentAt,
                    created_at:   sentAt,
                    MessageText:  msgText,
                    content:      msgText,
                    ChatType:     'OUT',
                    from_number:  null,
                    wa_status:    'sending',
                    temp:         true,
                }
            ]
        }));
        setNewMessage('');
        try {
            const res    = await fetch("https://wa-api.globebot.io/auth/send-message", {
                method:  "POST",
                headers: { "Content-Type": "application/json", "Authorization": `Bearer ${accessToken || ""}` },
                body:    JSON.stringify({
                    phone_number_id: selectedUser.phone_number_id,
                    to:              selectedUser.from_number,
                    message:         msgText,
                    access_token:    accessToken,
                })
            });
            const result = await res.json();
            const realId = result?.message_id;
            if (realId) {
                setChatsMap(prev => ({
                    ...prev,
                    [chatKey]: (prev[chatKey] || []).map(m =>
                        m.message_id === tempId ? { ...m, message_id: realId, wa_status: 'sent', temp: false } : m
                    )
                }));
            }
        } catch (err) {
            setChatsMap(prev => ({
                ...prev,
                [chatKey]: (prev[chatKey] || []).map(m =>
                    m.message_id === tempId ? { ...m, wa_status: 'failed' } : m
                )
            }));
        }
    };

    const dbMsgs     = allDbChats[chatKey] || [];
    const uiMsgs     = chatsMap[chatKey]   || [];
    const chatsArray = getCombinedMessages(dbMsgs, uiMsgs);

    const safeProfileName = getProfileName(selectedUser);
    const safeWANumber    = getWANumber(selectedUser);
    const firstMessage    = chatsArray[0];
    const lastMessage     = chatsArray[chatsArray.length - 1];
    const safeLastUserMsg = selectedUser?.LastUserMessage || selectedUser?.lastMessage
        || lastMessage?.MessageText || lastMessage?.content || lastMessage?.message || "";
    const safeTimePassed  = selectedUser?.TimePassed || "";

    function deduceChatType(chat) {
        if (chat.ChatType) return chat.ChatType;
        return isDbMessageIncoming(chat, selectedUser) ? 'IN' : 'OUT';
    }

    function formatDisplayDate(v) {
        if (!v) return '';
        try { const d = new Date(v); return isNaN(d) ? String(v) : d.toLocaleString(); } catch { return String(v); }
    }

    function formatDateLabel(date) {
        if (!date) return '';
        const d = new Date(date), today = new Date(), yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        if (d.toDateString() === today.toDateString())     return "Today";
        if (d.toDateString() === yesterday.toDateString()) return "Yesterday";
        return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    }

    const formatTime = (date) => {
        if (!date) return '';
        try { const d = new Date(date); return isNaN(d) ? String(date) : d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }); }
        catch { return String(date); }
    };

    const formattedLastTime = lastMessage
        ? formatDisplayDate(lastMessage.created_at || lastMessage.ReceivedDate)
        : formatDisplayDate(selectedUser?.lastTime || selectedUser?.last_message_time || "");

    function countdownColor() {
        if (!timeLeft || expired) return '#ed5050';
        const [h] = timeLeft.split(':').map(Number);
        return h < 2 ? '#f59e0b' : '#448c74';
    }

    function getTime() {
        const now = new Date();
        let h = now.getHours(); const ampm = h >= 12 ? 'PM' : 'AM'; h = h % 12 || 12;
        return `${String(now.getMonth()+1).padStart(2,'0')}/${String(now.getDate()).padStart(2,'0')}/${now.getFullYear()} ${String(h).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}${ampm}`;
    }

    const [AssignAgent, setAssignAgent] = useState(false);
    const [Notes,       setNotes]       = useState(false);
    const [Customer,    setCustomer]    = useState(false);
    const [Notestext,   setNotestext]   = useState('');
    const [AddNotes,    setAddNotes]    = useState([]);
    const [open,        setOpen]        = useState(false);
    const [editId,      setEditId]      = useState(null);

    function addNotes() {
        if (!Notestext.trim()) return;
        if (editId) {
            setAddNotes(prev => prev.map(item => item.id === editId ? { ...item, text: Notestext } : item));
            setEditId(null);
        } else {
            setAddNotes(prev => [...prev, { id: Date.now(), text: Notestext, time: getTime() }]);
        }
        setNotestext(''); setOpen(false);
    }
    const deleteNote = (id) => setAddNotes(prev => prev.filter(item => item.id !== id));

    const [allAgents, setAllAgents] = useState([]);
    const [assigningAgent, setAssigningAgent] = useState(false);
    const [assignError, setAssignError] = useState('');
    const [assignSuccess, setAssignSuccess] = useState(false);
    const [assignedAgentObj, setAssignedAgentObj] = useState(null);

    useEffect(() => {
        if (!accessToken) return;
        setAllAgents([]);
        fetch(`https://wa-api.globebot.io/auth/agents/by-account?user_id=${userId}`, {
            method: "GET",
            headers: { Authorization: `Bearer ${accessToken}` }
        })
          .then(r => r.ok ? r.json() : Promise.reject())
          .then(data => {
              if (typeof data === 'object' && Array.isArray(data.data)) {
                  setAllAgents(data.data);
              } else if (Array.isArray(data)) {
                  setAllAgents(data);
              } else {
                  setAllAgents([]);
              }
          })
          .catch(() => setAllAgents([]));
    }, [accessToken, userId]);

    useEffect(() => {
        setAssignSuccess(false);
        setAssignError('');
        if (selectedUser && selectedUser.assign_user) {
            setAssignedAgentObj(selectedUser.assign_user);
        }
        else setAssignedAgentObj(null);
    }, [selectedUser]);

    const assignAgentToUser = async (agent) => {
        if (!selectedUser?.from_number || !selectedUser?.phone_number_id || !agent?._id) return;
        setAssignError('');
        setAssignSuccess(false);
        setAssigningAgent(true);
        try {
            const res = await fetch('https://wa-api.globebot.io/auth/assign-user', {
                method: "POST",
                headers: { "Content-Type": "application/json", "Authorization": `Bearer ${accessToken}` },
                body: JSON.stringify({
                    from_number: selectedUser.from_number,
                    phone_number_id: selectedUser.phone_number_id,
                    assign_user_id: agent._id
                })
            });
            const result = await res.json();
            if (res.ok && (result.status === "success" || result.success)) {
                setAssignSuccess(true);
                setAssignedAgentObj(agent);
            } else {
                setAssignError(result.message || "Assignment failed. Try again.");
            }
        } catch (e) {
            setAssignError("Assignment failed. Try again.");
        }
        setAssigningAgent(false);
    };

    function exportChat() {
        if (!chatsArray.length) return;
        const rows = chatsArray.map((chat) => {
            const dateStr  = chat.created_at || chat.ReceivedDate || '';
            const chatType = deduceChatType(chat);
            const rawText  = chat.MessageText || chat.content || chat.message || '';
            let displayText = rawText;
            try {
                const p = JSON.parse(rawText);
                if (p?.name && p?.language !== undefined) {
                    const bodyComp = p.components?.find(c => (c.type || '').toLowerCase() === 'body');
                    let bodyText   = bodyComp?.text || '';
                    (bodyComp?.parameters || []).forEach((param, i) => {
                        bodyText = bodyText.replace(
                            new RegExp(`\\{\\{${i + 1}\\}\\}`, 'g'),
                            param.text || param.payload || ''
                        );
                    });
                    displayText = bodyText || `[Template: ${p.name}]`;
                }
            } catch { }
            const dateObj   = dateStr ? new Date(dateStr) : null;
            const dateLabel = dateObj && !isNaN(dateObj)
                ? dateObj.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
                : '';
            const timeLabel = dateObj && !isNaN(dateObj)
                ? dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                : '';
            return {
                Date:        dateLabel,
                Time:        timeLabel,
                Direction:   chatType === 'IN' ? 'Incoming' : 'Outgoing',
                Sender:      chatType === 'IN' ? safeProfileName : 'Agent',
                'WA Number': safeWANumber,
                Message:     displayText,
                Status:      chat.wa_status || chat.status || '',
            };
        });
        const totalMsgs    = rows.length;
        const incoming     = rows.filter(r => r.Direction === 'Incoming').length;
        const outgoing     = rows.filter(r => r.Direction === 'Outgoing').length;
        const firstMsgDate = rows[0]?.Date || '—';
        const lastMsgDate  = rows[rows.length - 1]?.Date || '—';
        const tally = [
            { Metric: 'Customer Name',    Value: safeProfileName },
            { Metric: 'WA Number',        Value: safeWANumber    },
            { Metric: 'Export Date',      Value: new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) },
            { Metric: '',                 Value: ''              },
            { Metric: 'Total Messages',   Value: totalMsgs       },
            { Metric: 'Incoming',         Value: incoming        },
            { Metric: 'Outgoing',         Value: outgoing        },
            { Metric: '',                 Value: ''              },
            { Metric: 'First Message',    Value: firstMsgDate    },
            { Metric: 'Last Message',     Value: lastMsgDate     },
            { Metric: 'Window Status',    Value: expired ? 'Closed' : `Open — ${timeLeft} remaining` },
            ...(isAssigned ? [{ Metric: 'Assigned Agent', Value: currentAssignment.agent_name }] : []),
        ];
        const wb = XLSX.utils.book_new();
        const wsChatData   = XLSX.utils.json_to_sheet(rows);
        wsChatData['!cols'] = [
            { wch: 14 }, // Date
            { wch: 8  }, // Time
            { wch: 11 }, // Direction
            { wch: 20 }, // Sender
            { wch: 18 }, // WA Number
            { wch: 60 }, // Message
            { wch: 12 }, // Status
        ];
        XLSX.utils.book_append_sheet(wb, wsChatData, 'Chat History');
        const wsTally = XLSX.utils.json_to_sheet(tally);
        wsTally['!cols'] = [{ wch: 20 }, { wch: 40 }];
        XLSX.utils.book_append_sheet(wb, wsTally, 'Summary');
        const safeName = (safeProfileName || safeWANumber || 'chat').replace(/[^a-zA-Z0-9_-]/g, '_');
        XLSX.writeFile(wb, `chat_${safeName}.xlsx`);
    }

    return (
        <>
            <div className='w-[100%] flex h-auto'>
                {/* ══════════════ CHAT PANEL ══════════════ */}
                <div
                    style={{ backgroundImage: `url(${chatBg})`, height: '600px' }}
                    className='w-[60%] bg-cover bg-center flex flex-col'
                >
                    {/* Header */}
                    <div className='w-[100%] border-[#e3e9ef] border-b-[1px] py-2 px-4 flex gap-4 items-center justify-between bg-white shrink-0'>
                        <div className='flex gap-4 items-center hidden'>
                            <div className='w-[55px] h-[55px] bg-[#0000000d] rounded-full flex justify-center items-center text-[24px] uppercase font-semibold text-[#576071]'>
                                {safeProfileName.slice(0, 2)}
                            </div>
                            <div>
                                <h3 className='text-[#000] text-[15px] font-bold capitalize'>{safeProfileName}</h3>
                                <h3 className='text-[#858c97] text-[13px] font-semibold'>{safeWANumber}</h3>
                            </div>
                        </div>
                        {/* 24hr countdown badge */}
                        {windowStartAt ? (
                            <div
                                style={{ backgroundColor: countdownColor() }}
                                className='flex flex-col items-center px-3 py-1 rounded-lg text-white min-w-[110px] transition-all duration-500'
                            >
                                <span className='text-[9px] font-bold uppercase tracking-wider'>
                                    {expired ? 'Window Closed' : '24hr Window'}
                                </span>
                                <span className='text-[15px] font-bold font-mono tracking-widest'>{timeLeft}</span>
                            </div>
                        ) : (
                            <div className='flex flex-col items-center px-3 py-1 rounded-lg bg-gray-200 text-gray-500 min-w-[110px]'>
                                <span className='text-[9px] font-bold uppercase tracking-wider'>No Window</span>
                                <span className='text-[11px] font-semibold'>Awaiting msg</span>
                            </div>
                        )}
                    </div>
                    {/* ── Messages ── */}
                    <div className='flex-1 overflow-y-auto px-2 py-2'>
                        {chatsArray.length > 0 ? (
                            chatsArray.map((chat, index) => {
                                const dateStr   = chat.created_at || chat.ReceivedDate;
                                const prevDate  = index > 0
                                    ? new Date(chatsArray[index-1].created_at || chatsArray[index-1].ReceivedDate).toDateString()
                                    : null;
                                const showDate  = !prevDate || new Date(dateStr).toDateString() !== prevDate;
                                const chatType  = deduceChatType(chat);
                                const msgText   = chat.MessageText || chat.content || chat.message || "";
                                const msgStatus = chat.wa_status || chat.status;
                                const isOutgoing = chatType !== 'IN';
                                return (
                                    <div className='w-[100%]' key={chat.message_id || chat.id || dateStr || index}>
                                        {showDate && (
                                            <div className="text-center my-3">
                                                <span className="bg-gray-200 text-xs px-3 py-1 rounded-full font-bold text-[#434a57]">
                                                    {formatDateLabel(dateStr)}
                                                </span>
                                            </div>
                                        )}
                                        {!isOutgoing ? (
                                            <div className='flex gap-2 justify-start mb-3'>
                                                <div className='w-[44px] h-[44px] bg-[#3f7fca26] rounded-full flex justify-center items-center text-[16px] uppercase font-semibold text-[#3f7fca] shrink-0'>
                                                    {safeProfileName.slice(0, 2)}
                                                </div>
                                                <div className='max-w-[65%]'>
                                                    <div className='bg-[#3f80ca15] p-3 text-[13px] font-semibold text-[#121519d1] rounded-t-[20px] rounded-r-[20px] rounded-bl-none'>
                                                        {renderMessageContent(msgText, false)}
                                                    </div>
                                                    <p className='text-[#858c97] text-[11px] font-semibold mt-1'>{formatTime(dateStr)}</p>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className='w-[100%] mb-3'>
                                                <div className="flex justify-center items-center my-1">
                                                    <span className="bg-gray-200 text-xs px-3 py-1 rounded-full font-bold text-[#434a57]">
                                                        service message sent
                                                    </span>
                                                </div>
                                                <div className='flex gap-2 justify-end items-end'>
                                                    <div className='max-w-[65%]'>
                                                        <div className='bg-[#448c74] p-3 text-[13px] font-semibold text-white rounded-t-[20px] rounded-l-[20px] rounded-br-none flex items-end gap-2'>
                                                            <div className='flex-1'>
                                                                {renderMessageContent(msgText, true)}
                                                            </div>
                                                            <MessageTick status={msgStatus} />
                                                        </div>
                                                        <p className='text-[#858c97] text-[11px] font-semibold text-end mt-1'>{formatTime(dateStr)}</p>
                                                    </div>
                                                    <img className='w-[44px] h-[44px] shrink-0' src={SenderIcon} alt="" />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })
                        ) : (
                            <div className='text-center text-gray-400 p-10'>No chat history available.</div>
                        )}
                        <div ref={chatListEndRef} />
                    </div>
                    {/* ── Input area ── */}
                    <div className="w-full flex flex-col p-2 border-t bg-white shrink-0">
                        {!windowStartAt && (
                            <div className='w-full text-center text-[12px] text-[#858c97] font-semibold mb-2 bg-[#f6f9fc] py-2 rounded-lg border border-[#ddd]'>
                                💬 Waiting for the customer to send a message first to open the 24hr window.
                            </div>
                        )}
                        {needsRenewAck && (
                            <div className='w-full mb-2 bg-[#fffbe6] border border-[#f59e0b] rounded-lg px-3 py-2 flex items-start gap-2'>
                                <input
                                    type="checkbox"
                                    id={`renew_${chatKey}`}
                                    checked={renewChecked[chatKey]}
                                    onChange={(e) => setRenewChecked(prev => ({ ...prev, [chatKey]: e.target.checked }))}
                                    className='mt-[3px] w-[15px] h-[15px] accent-[#448c74] cursor-pointer shrink-0'
                                />
                                <label htmlFor={`renew_${chatKey}`} className='text-[12px] text-[#856404] font-semibold cursor-pointer leading-snug'>
                                    Customer sent a new message — tick to re-open the 24hr messaging window and reply.
                                </label>
                            </div>
                        )}
                        {expired && !windowFresh && windowStartAt && (
                            <div className='w-full text-center text-[12px] text-[#ed5050] font-semibold mb-2 bg-[#fff0f0] py-2 rounded-lg border border-[#ed5050]'>
                                ⛔ 24-hr window closed. You can only send template messages until the customer replies.
                            </div>
                        )}
                        <div className='flex'>
                            <input
                                type="text"
                                value={newMessage}
                                onChange={(e) => setNewMessage(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                                placeholder={
                                    !windowStartAt            ? "Waiting for customer to message first..." :
                                    needsRenewAck             ? "Tick the checkbox above to enable reply..." :
                                    (expired && !windowFresh) ? "Window closed — use a template message..." :
                                                                "Type a message..."
                                }
                                disabled={!effectiveCanSend}
                                className={`flex-1 border rounded-lg px-3 py-2 outline-none text-[13px] transition-colors ${
                                    !effectiveCanSend ? 'bg-gray-100 cursor-not-allowed text-gray-400' : 'bg-white'
                                }`}
                            />
                            <button
                                onClick={sendMessage}
                                disabled={!effectiveCanSend}
                                className={`ml-2 px-4 rounded-lg text-white font-semibold text-[13px] transition-colors ${
                                    !effectiveCanSend ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#128C7E] hover:bg-[#075E54]'
                                }`}
                            >
                                Send
                            </button>
                        </div>
                    </div>
                </div>

                {/* ══════════════ RIGHT PANEL ══════════════ */}
                <div className='w-[40%] p-6 bg-[#fff] min-h-screen overflow-y-auto'>
                    <div className='w-[100%] rounded-lg'>
                        <div className='w-[100%] flex gap-2 bg-gradient-to-br from-[#075E54] to-[#128C7E] p-6 rounded-t-[20px] items-center'>
                            <div className='w-[50px] h-[50px] bg-[#ada426] rounded-lg flex justify-center items-center text-[20px] uppercase font-semibold text-white shrink-0'>
                                {safeProfileName.slice(0, 2)}
                            </div>
                            <div className='flex-1 min-w-0'>
                                <h1 className='text-[15px] text-white font-semibold truncate'>{safeProfileName}</h1>
                                <h1 className='text-[13px] text-white'>{safeWANumber}</h1>
                            </div>
                            <div
                                onClick={exportChat}
                                className='text-[13px] text-white font-semibold flex items-center gap-1 cursor-pointer hover:opacity-80 select-none shrink-0'
                            >
                                <LuSquareArrowOutUpRight /> Export Chat
                            </div>
                        </div>
                        <div className='bg-[#e5ddd536] w-[100%] p-4'>
                            <div className='flex items-center justify-between w-[100%]'>
                                <span className='text-[#576071e0] text-[13px] font-semibold'>Last Message On</span>
                                <span className='text-[#576071e0] text-[13px] font-semibold'>{formattedLastTime || 'N/A'}</span>
                            </div>
                            <div className='flex items-center justify-between w-[100%] mt-2'>
                                <span className='text-[#576071e0] text-[13px] font-semibold'>Last Active</span>
                                <span className='text-[#576071e0] text-[13px] font-semibold'>{safeTimePassed}</span>
                            </div>
                            <div className='flex items-center justify-between w-[100%] mt-2'>
                                <span className='text-[#576071e0] text-[13px] font-semibold'>Last Message</span>
                                <span className='text-[#576071e0] text-[13px] font-semibold truncate max-w-[55%]'>{safeLastUserMsg}</span>
                            </div>
                            <div className='flex items-center justify-between w-[100%] mt-2 border-t border-[#ddd] pt-2'>
                                <span className='text-[#576071e0] text-[13px] font-semibold'>Msg Window</span>
                                <span style={{ color: countdownColor() }} className='text-[13px] font-bold font-mono'>
                                    {!windowStartAt ? '—' : expired ? 'Closed' : timeLeft}
                                </span>
                            </div>
                            <div className='w-[100%] mt-6'>
                                <span className='text-[18px] text-[#448c74] flex font-semibold items-center gap-1'>
                                    Actions <FaArtstation />
                                </span>
                            </div>
                            <div className='w-[100%] border-[#000] border-t-[1px]'>
                                {/* Assign Agent */}
                                <div className='bg-[#f6f9fc] border-[#ddd] border rounded-lg mt-2'>
                                    <div
                                        onClick={() => setAssignAgent(!AssignAgent)}
                                        className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer p-2 rounded-t-lg select-none ${AssignAgent ? 'bg-[#edf1f5]' : ''}`}
                                    >
                                        <span className='flex items-center gap-2'>
                                            <FaUser className='text-[#448c74]' />
                                            Assign Agent
                                            {isAssigned && (
                                                <span className='inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#e8f8f2] text-[#37715d] text-[11px] font-bold border border-[#c3edd9]'>
                                                    <span className='w-1.5 h-1.5 rounded-full bg-[#16D39A]' />
                                                    {currentAssignment.agent_name}
                                                </span>
                                            )}
                                        </span>
                                        {AssignAgent ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                    </div>
                                    {AssignAgent && (
                                        <div className='p-3'>
                                            {agentsLoading && (
                                                <div className='text-[#448c74] text-[13px] py-2'>Loading agents…</div>
                                            )}
                                            {assignError && (
                                                <p className='text-red-400 text-[12px] mb-2'>{assignError}</p>
                                            )}
                                            {!agentsLoading && (
                                                <div className='flex flex-wrap gap-2'>
                                                    {agents.length === 0 && (
                                                        <p className='text-[#858c97] text-[12px]'>No agents available.</p>
                                                    )}
                                                    {agents.map(agent => {
                                                        const isActive         = selectedAgentId === agent.id;
                                                        const isAssignedToThis = currentAssignment?.agent_id === agent.id && isAssigned;
                                                        return (
                                                            <button
                                                                key={agent.id}
                                                                onClick={() => setSelectedAgentId(isActive ? null : agent.id)}
                                                                disabled={assigning}
                                                                className={`flex items-center gap-1.5 border rounded-lg px-3 py-1.5 text-[12px] font-semibold transition-all duration-150
                                                                    ${isAssignedToThis
                                                                        ? 'bg-[#448c74] text-white border-[#448c74]'
                                                                        : isActive
                                                                            ? 'bg-[#16D39A] text-white border-[#16D39A] shadow-md scale-105'
                                                                            : 'border-[#448c74] text-[#448c74] hover:bg-[#448c74] hover:text-white'
                                                                    } disabled:opacity-60`}
                                                            >
                                                                {isAssignedToThis && <span className='text-[10px]'>✓</span>}
                                                                <span>{agent.name}</span>
                                                                {isAssignedToThis && <span className='text-[10px] opacity-80'>(assigned)</span>}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                            {/* Confirm assign */}
                                            {canSend && (
                                                <div className='mt-3 flex items-center gap-2'>
                                                    <button
                                                        onClick={handleAssign}
                                                        disabled={assigning}
                                                        className='flex items-center gap-2 px-4 py-2 bg-[#448c74] hover:bg-[#37715d] text-white text-[13px] font-bold rounded-lg transition-all disabled:opacity-60'
                                                    >
                                                        {assigning ? 'Assigning…' : `Assign to ${stagedAgent?.name}`}
                                                    </button>
                                                    <button
                                                        onClick={() => setSelectedAgentId(currentAssignment?.agent_id || null)}
                                                        disabled={assigning}
                                                        className='px-3 py-2 text-[12px] font-semibold text-[#576071] bg-[#edf1f5] hover:bg-[#d3dde6] rounded-lg'
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            )}
                                            {/* Unassign */}
                                            {isAssigned && !canSend && (
                                                <div className='mt-3'>
                                                    <button
                                                        onClick={handleUnassign}
                                                        disabled={assigning}
                                                        className='flex items-center gap-2 px-4 py-2 bg-white border border-[#ed5050] text-[#ed5050] hover:bg-[#ed5050] hover:text-white text-[12px] font-bold rounded-lg transition-all disabled:opacity-60'
                                                    >
                                                        {assigning ? 'Unassigning…' : `Unassign ${currentAssignment.agent_name}`}
                                                    </button>
                                                </div>
                                            )}
                                            {isAssigned && !canSend && !assigning && (
                                                <p className='mt-2 text-[12px] text-[#448c74] font-semibold'>
                                                    ✓ Chat assigned to {currentAssignment.agent_name}
                                                </p>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {/* Notes */}
                                <div className='bg-[#f6f9fc] border-[#ddd] border rounded-lg mt-2'>
                                    <div onClick={() => setNotes(!Notes)}
                                        className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer p-2 rounded-t-lg ${Notes ? 'bg-[#edf1f5]' : ''}`}>
                                        Notes {Notes ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                    </div>
                                    {Notes && (
                                        <div className='mt-2 p-2'>
                                            <button onClick={() => setOpen(true)}
                                                className='border border-[#448c74] rounded-lg p-2 bg-[#448c74] text-white text-[12px] font-semibold'>
                                                <MdAdd />
                                            </button>
                                            {AddNotes.length > 0 ? AddNotes.map(item => (
                                                <div className='w-[100%] mt-2' key={item.id}>
                                                    <div className='w-[100%] bg-[#fff9db] p-2 rounded'>
                                                        <div className='flex justify-between gap-2 items-center'>
                                                            <div className='w-[32px] h-[32px] rounded-full bg-[#eee] flex justify-center items-center shrink-0'>
                                                                <FaUser />
                                                            </div>
                                                            <div className='flex-1 min-w-0'>
                                                                <h1 className='text-[#576071] text-[12px] font-semibold truncate'>{safeProfileName}</h1>
                                                                <h1 className='text-[#576071] text-[11px]'>{item.time}</h1>
                                                            </div>
                                                            <div className='flex gap-1 shrink-0'>
                                                                <button onClick={() => { setEditId(item.id); setOpen(true); setNotestext(item.text); }}
                                                                    className='p-1.5 border border-[#448c74] rounded-md text-[#448c74] hover:text-white hover:bg-[#448c74]'>
                                                                    <FaEdit size={12} />
                                                                </button>
                                                                <button onClick={() => deleteNote(item.id)}
                                                                    className='p-1.5 border border-[#ed5050] rounded-md text-[#ed5050] hover:text-white hover:bg-[#ed5050]'>
                                                                    <MdDelete size={12} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <p className='text-[12px] text-[#576071] font-semibold mt-2'>{item.text}</p>
                                                    </div>
                                                </div>
                                            )) : (
                                                <p className='w-[100%] text-center text-[#858c97] text-[13px] mt-2'>No notes available</p>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {/* Customer Journey */}
                                <div className='bg-[#f6f9fc] border-[#ddd] border rounded-lg mt-2'>
                                    <div onClick={() => setCustomer(!Customer)}
                                        className={`flex justify-between items-center text-[#576071] font-semibold cursor-pointer p-2 rounded-t-lg ${Customer ? 'bg-[#edf1f5]' : ''}`}>
                                        Customer Journey {Customer ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                    </div>
                                    {Customer && (
                                        <div className='flex pb-4 px-3 pt-3 gap-3'>
                                            <div className='flex flex-col items-center gap-1'>
                                                <div className='w-[10px] h-[10px] bg-[#000] rounded-full'></div>
                                                <div className='w-[1px] h-[30px] bg-[#000]'></div>
                                            </div>
                                            <div>
                                                <h5 className='text-[#576071] text-[12px] font-bold'>User Created</h5>
                                                <h5 className='text-[#576071] text-[11px]'>
                                                    {firstMessage ? formatTime(firstMessage.created_at || firstMessage.ReceivedDate) : '—'}
                                                </h5>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Notes Modal */}
            <AddNotesModal isOpen={open} onClose={() => { setOpen(false); setNotestext(''); setEditId(null); }} heading={editId ? 'Edit Note' : 'Add Note'}>
                <textarea
                    className='border border-[#d4cfcf] w-[100%] rounded-lg outline-none mt-4 p-2'
                    placeholder='Write your note...'
                    rows={4}
                    value={Notestext}
                    onChange={(e) => setNotestext(e.target.value)}
                />
                <div className='w-[100%] flex items-center justify-end mt-4 gap-2'>
                    <button onClick={() => { setOpen(false); setNotestext(''); setEditId(null); }}
                        className='bg-[#edf1f5] hover:bg-[#d3dde6] text-[14px] font-semibold p-2 rounded-lg'>Cancel</button>
                    <button onClick={addNotes}
                        className='bg-[#3fca90] hover:bg-[#31b07b] text-[14px] text-white font-semibold p-2 rounded-lg'>Save</button>
                </div>
            </AddNotesModal>
        </>
    );
}

export default Whatapplivechat;